import { Component, ViewEncapsulation, HostBinding, Input, Directive, ContentChildren, HostListener, Injectable, ɵɵdefineInjectable, ViewChildren, ElementRef, Renderer2, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef, ComponentFactoryResolver, ViewChild, ViewContainerRef, InjectionToken, Inject, ApplicationRef, Injector, NgModule } from '@angular/core';
import { FormControl, FormArray, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbDatepickerI18n, NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { trigger, state, style, transition, group, animate } from '@angular/animations';
import { A11yModule } from '@angular/cdk/a11y';
import { DOCUMENT, CommonModule } from '@angular/common';
import Fuse from 'fuse.js';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/alert/alert.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@angular/cdk/a11y';

function AlertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} }
const _c0 = ["*"];
const _c1 = ["autotab"];
const _c2 = ["dlg-button", ""];
const _c3 = ["datepicker"];
function CalendarComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const date_r3 = ctx.date;
    const focused_r4 = ctx.focused;
    const selected_r5 = ctx.selected;
    const disabled_r6 = ctx.disabled;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("focused", focused_r4)("bg-primary", selected_r5)("text-muted", disabled_r6)("outside", disabled_r6);
    ɵngcc0.ɵɵattribute("data-analytics-link-name", ctx_r2.analyticsComponentPrefix + "DaySelected");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", date_r3.day, " ");
} }
const _c4 = function () { return { standalone: true }; };
function FieldComponent_div_0_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r4.labelFor + "-label");
    ɵngcc0.ɵɵattribute("for", ctx_r4.labelFor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.config.label);
} }
function FieldComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FieldComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, FieldComponent_div_0_label_1_Template, 2, 3, "label", 2);
    ɵngcc0.ɵɵtemplate(2, FieldComponent_div_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config == null ? null : ctx_r0.config.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function FieldComponent_fieldset_1_legend_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "legend", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r6.labelFor + "-label");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.config.label, " ");
} }
function FieldComponent_fieldset_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FieldComponent_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "fieldset");
    ɵngcc0.ɵɵtemplate(1, FieldComponent_fieldset_1_legend_1_Template, 2, 2, "legend", 2);
    ɵngcc0.ɵɵtemplate(2, FieldComponent_fieldset_1_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵattribute("aria-describedby", (ctx_r1.config == null ? null : ctx_r1.config.hint) ? ctx_r1.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.config == null ? null : ctx_r1.config.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function FieldComponent_ng_template_2_dlg_hint_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dlg-hint", 8);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r8.labelFor + "-hint");
    ɵngcc0.ɵɵproperty("hint", ctx_r8.config == null ? null : ctx_r8.config.hint)("isDisabled", ctx_r8.control == null ? null : ctx_r8.control.disabled);
} }
function FieldComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9)(1, "span", 10);
    ɵngcc0.ɵɵtext(2, "Error:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("@slideInOut", undefined);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r9.errorMessage, ɵngcc0.ɵɵsanitizeHtml);
} }
function FieldComponent_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r10.errorMessage, ɵngcc0.ɵɵsanitizeHtml);
} }
function FieldComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, FieldComponent_ng_template_2_dlg_hint_0_Template, 1, 3, "dlg-hint", 5);
    ɵngcc0.ɵɵtemplate(1, FieldComponent_ng_template_2_div_1_Template, 4, 2, "div", 6);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵtemplate(3, FieldComponent_ng_template_2_div_3_Template, 1, 1, "div", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.config == null ? null : ctx_r3.config.hint);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.errorMessage && ctx_r3.layout === ctx_r3.Layout.A11y);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.errorMessage && ctx_r3.layout === ctx_r3.Layout.Default);
} }
function CheckboxesComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "input", 6);
    ɵngcc0.ɵɵlistener("click", function CheckboxesComponent_ng_container_1_div_1_Template_input_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r5.setFocus($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", i_r4)("value", ctx_r2.displayAsValue(option_r3));
    ɵngcc0.ɵɵattribute("id", ctx_r2.field.config.name + "-" + i_r4)("name", ctx_r2.field.config.name)("aria-describedby", (ctx_r2.field.config == null ? null : ctx_r2.field.config.hint) ? ctx_r2.field.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r2.field.config.name + "-" + i_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.displayAsValue(option_r3));
} }
function CheckboxesComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 3);
    ɵngcc0.ɵɵtemplate(1, CheckboxesComponent_ng_container_1_div_1_Template, 4, 7, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r0.field.config.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.field.config.options);
} }
function CheckboxesComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5)(2, "input", 6);
    ɵngcc0.ɵɵlistener("click", function CheckboxesComponent_ng_container_2_Template_input_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.setFocus($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.field.config.name)("value", ctx_r1.field.config.options[0]);
    ɵngcc0.ɵɵattribute("id", ctx_r1.field.labelFor)("name", ctx_r1.field.labelFor)("aria-describedby", (ctx_r1.field.config == null ? null : ctx_r1.field.config.hint) ? ctx_r1.field.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r1.field.labelFor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.displayAsValue(ctx_r1.field.config.options[0]));
} }
function DatepickerComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Day");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 3, 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r2.field.labelFor + "-day");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("type", ctx_r2.type)("id", ctx_r2.field.labelFor + "-day")("name", ctx_r2.field.labelFor)("inputmode", ctx_r2.numericKeypad ? "numeric" : null)("pattern", ctx_r2.numericKeypad ? "[0-9]*" : null)("aria-describedby", (ctx_r2.field.config == null ? null : ctx_r2.field.config.hint) ? ctx_r2.field.labelFor + "-hint" : null);
} }
function DatepickerComponent_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Month");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 5, 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r3.field.labelFor + "-month");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("type", ctx_r3.type)("id", ctx_r3.field.labelFor + "-month")("name", ctx_r3.field.labelFor)("inputmode", ctx_r3.numericKeypad ? "numeric" : null)("pattern", ctx_r3.numericKeypad ? "[0-9]*" : null)("aria-describedby", (ctx_r3.field.config == null ? null : ctx_r3.field.config.hint) ? ctx_r3.field.labelFor + "-hint" : null);
} }
function DatepickerComponent_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Year");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 6, 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r4.field.labelFor + "-year");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("type", ctx_r4.type)("id", ctx_r4.field.labelFor + "-year")("name", ctx_r4.field.labelFor)("inputmode", ctx_r4.numericKeypad ? "numeric" : null)("pattern", ctx_r4.numericKeypad ? "[0-9]*" : null)("aria-describedby", (ctx_r4.field.config == null ? null : ctx_r4.field.config.hint) ? ctx_r4.field.labelFor + "-hint" : null);
} }
function DatepickerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DatepickerComponent_ng_container_2_ng_container_1_Template, 5, 7, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, DatepickerComponent_ng_container_2_ng_container_2_Template, 5, 7, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(3, DatepickerComponent_ng_container_2_ng_container_3_Template, 5, 7, "ng-container", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.display.days);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.display.months);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.display.years);
} }
function DatepickerComponent_ng_container_3_ng_container_2_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", option_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r12, " ");
} }
function DatepickerComponent_ng_container_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8)(2, "label");
    ɵngcc0.ɵɵtext(3, "Day");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 9);
    ɵngcc0.ɵɵlistener("change", function DatepickerComponent_ng_container_3_ng_container_2_Template_select_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.onChange($event, "day")); });
    ɵngcc0.ɵɵelementStart(5, "option", 10);
    ɵngcc0.ɵɵtext(6, "DD");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DatepickerComponent_ng_container_3_ng_container_2_option_7_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r8.displayLabel ? "field-container" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r8.field.labelFor + "-day");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r8.field.labelFor + "-day")("name", ctx_r8.field.labelFor)("aria-describedby", (ctx_r8.field.config == null ? null : ctx_r8.field.config.hint) ? ctx_r8.field.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.days);
} }
function DatepickerComponent_ng_container_3_ng_container_3_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r16 = ctx.$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", option_r16);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r15.showMonthAsNumber ? option_r16 : ctx_r15.formatMonth(option_r16), " ");
} }
function DatepickerComponent_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8)(2, "label");
    ɵngcc0.ɵɵtext(3, "Month");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 13);
    ɵngcc0.ɵɵlistener("change", function DatepickerComponent_ng_container_3_ng_container_3_Template_select_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r17.onChange($event, "month")); });
    ɵngcc0.ɵɵelementStart(5, "option", 10);
    ɵngcc0.ɵɵtext(6, "MM");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DatepickerComponent_ng_container_3_ng_container_3_option_7_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.displayLabel ? "field-container" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r9.field.labelFor + "-month");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r9.field.labelFor + "-month")("name", ctx_r9.field.labelFor)("aria-describedby", (ctx_r9.field.config == null ? null : ctx_r9.field.config.hint) ? ctx_r9.field.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.months);
} }
function DatepickerComponent_ng_container_3_ng_container_4_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r20 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", option_r20);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r20, " ");
} }
function DatepickerComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8)(2, "label");
    ɵngcc0.ɵɵtext(3, "Year");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 14);
    ɵngcc0.ɵɵlistener("change", function DatepickerComponent_ng_container_3_ng_container_4_Template_select_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r21.onChange($event, "year")); });
    ɵngcc0.ɵɵelementStart(5, "option", 10);
    ɵngcc0.ɵɵtext(6, "YYYY");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DatepickerComponent_ng_container_3_ng_container_4_option_7_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r10.displayLabel ? "field-container" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r10.field.labelFor + "-year");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r10.field.labelFor + "-year")("name", ctx_r10.field.labelFor)("aria-describedby", (ctx_r10.field.config == null ? null : ctx_r10.field.config.hint) ? ctx_r10.field.labelFor + "-hint" : null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.years);
} }
function DatepickerComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtemplate(2, DatepickerComponent_ng_container_3_ng_container_2_Template, 8, 6, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(3, DatepickerComponent_ng_container_3_ng_container_3_Template, 8, 6, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(4, DatepickerComponent_ng_container_3_ng_container_4_Template, 8, 6, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.display.days);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.display.months);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.display.years);
} }
function HintComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.hint.text, ɵngcc0.ɵɵsanitizeHtml);
} }
function HintComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HintComponent_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.toggle($event)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "span", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("dlg-hint__toggle--expanded", ctx_r1.isExpanded);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.isDisabled);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r1.isExpanded)("aria-controls", ctx_r1.field.config.name + "-hint");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.hint.readMoreLabel ? ctx_r1.hint.readMoreLabel : ctx_r1.isExpanded ? "Less " + (ctx_r1.abbreviated ? "info" : "information") : "More " + (ctx_r1.abbreviated ? "info" : "information"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("on ", ctx_r1.field.config.label, "");
} }
function HintComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.hint.moreText, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("id", ctx_r2.field.config.name + "-hint");
} }
const _c5 = ["childComponentLocation"];
const _c6 = ["modal"];
const _c7 = ["modalBackdrop"];
function RadioComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "input", 2);
    ɵngcc0.ɵɵlistener("click", function RadioComponent_div_0_Template_input_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.setFocus($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.field.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.field.config.name)("value", option_r1);
    ɵngcc0.ɵɵattribute("id", ctx_r0.displayAsId(option_r1))("name", ctx_r0.field.labelFor)("aria-label", ctx_r0.field.config.ariaLabels ? ctx_r0.field.config.ariaLabels[i_r2] : undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", ctx_r0.displayAsId(option_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.displayAsValue(option_r1));
} }
function SelectComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.field.config.placeholder, " ");
} }
function SelectComponent_ng_container_3_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", option_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.displayAsValue(option_r4), " ");
} }
function SelectComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SelectComponent_ng_container_3_option_1_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.field.config.options);
} }
function SelectComponent_ng_container_4_optgroup_1_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const optionInGroup_r8 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", ctx_r7.displayAsValue(optionInGroup_r8));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.displayAsValue(optionInGroup_r8), " ");
} }
function SelectComponent_ng_container_4_optgroup_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "optgroup", 8);
    ɵngcc0.ɵɵtemplate(1, SelectComponent_ng_container_4_optgroup_1_option_1_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const optionGroup_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("label", optionGroup_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.field.config.options[optionGroup_r6]);
} }
function SelectComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SelectComponent_ng_container_4_optgroup_1_Template, 2, 2, "optgroup", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.optionGroups);
} }
const _c8 = ["panel"];
function TypeaheadComponent_ul_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 6);
    ɵngcc0.ɵɵlistener("mousedown", function TypeaheadComponent_ul_2_li_2_Template_li_mousedown_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const option_r3 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r4.setValue(option_r3)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("is-active", ctx_r2.activeValue === option_r3);
    ɵngcc0.ɵɵattribute("aria-selected", ctx_r2.activeValue === option_r3)("aria-posinset", ctx_r2.optionPosition(option_r3))("aria-setsize", ctx_r2.items == null ? null : ctx_r2.items.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.displayAsValue(option_r3), " ");
} }
function TypeaheadComponent_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 3, 4);
    ɵngcc0.ɵɵtemplate(2, TypeaheadComponent_ul_2_li_2_Template, 2, 6, "li", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filteredOptions);
} }
const COMPONENT_CLASS = 'dlg-alert';
class AlertComponent {
    constructor() {
        this.hasType = false;
        this.classList = '';
        this.attrClass = true;
    }
    /**
     * @param {?} type
     * @return {?}
     */
    set type(type) {
        if (type) {
            this.hasType = true;
            this.classList += ` ${COMPONENT_CLASS}--${type}`;
        }
        else {
            this.hasType = false;
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.classList = COMPONENT_CLASS + this.classList;
    }
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); };
AlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["dlg-alert"]], hostVars: 4, hostBindings: function AlertComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.classList);
        ɵngcc0.ɵɵclassProp("dlg-alert", ctx.attrClass);
    } }, inputs: { classList: ["class", "classList"], type: "type" }, ngContentSelectors: _c0, decls: 3, vars: 1, consts: [["class", "dlg-alert__icon", 4, "ngIf"], [1, "dlg-alert__message"], [1, "dlg-alert__icon"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, AlertComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasType);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2 });
AlertComponent.propDecorators = {
    classList: [{ type: HostBinding, args: ['class',] }, { type: Input, args: ['class',] }],
    attrClass: [{ type: HostBinding, args: [`class.${COMPONENT_CLASS}`,] }],
    type: [{ type: Input, args: ['type',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-alert',
                template: "<div class=\"dlg-alert__icon\" *ngIf=\"hasType\"></div>\n<div class=\"dlg-alert__message\">\n  <ng-content></ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { classList: [{
            type: HostBinding,
            args: ['class']
        }, {
            type: Input,
            args: ['class']
        }], attrClass: [{
            type: HostBinding,
            args: [`class.${COMPONENT_CLASS}`]
        }], type: [{
            type: Input,
            args: ['type']
        }] }); })();
if (false) {
    /** @type {?} */
    AlertComponent.prototype.hasType;
    /** @type {?} */
    AlertComponent.prototype.classList;
    /** @type {?} */
    AlertComponent.prototype.attrClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/autotab/autotab.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutotabDirective {
    constructor() { }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        /** @type {?} */
        const formElement = event.target || event.srcElement;
        this.mapElements();
        this.controlIndex = this.formElementIds.findIndex((/**
         * @param {?} item
         * @return {?}
         */
        item => item === formElement.id));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyUp(event) {
        // regex for any single character including whitespace
        /** @type {?} */
        const regex = /.+/g;
        if (event.key.length === 1 && regex.test(event.key)) {
            /** @type {?} */
            const formElement = event.target || event.srcElement;
            /** @type {?} */
            const maxLength = parseInt(formElement['maxLength'], 10);
            /** @type {?} */
            const userInputLength = parseInt(formElement['value'].length, 10);
            if (userInputLength === maxLength) {
                if (this.controlIndex + 1 < this.formElements.length) {
                    this.formElements[this.controlIndex + 1].nativeElement.focus();
                }
            }
        }
    }
    /**
     * @return {?}
     */
    mapElements() {
        this.formElements = this.autotab.toArray() || [];
        this.formElementIds = this.formElements.map((/**
         * @param {?} item
         * @return {?}
         */
        item => {
            return item.nativeElement.id;
        }));
    }
}
AutotabDirective.ɵfac = function AutotabDirective_Factory(t) { return new (t || AutotabDirective)(); };
AutotabDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AutotabDirective, selectors: [["", "dlgAutotab", ""]], contentQueries: function AutotabDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autotab = _t);
    } }, hostBindings: function AutotabDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function AutotabDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup", function AutotabDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/** @nocollapse */
AutotabDirective.ctorParameters = () => [];
AutotabDirective.propDecorators = {
    autotab: [{ type: ContentChildren, args: ['autotab', { descendants: true },] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    onKeyUp: [{ type: HostListener, args: ['keyup', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutotabDirective, [{
        type: Directive,
        args: [{
                selector: '[dlgAutotab]'
            }]
    }], function () { return []; }, { 
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], autotab: [{
            type: ContentChildren,
            args: ['autotab', { descendants: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    AutotabDirective.prototype.autotab;
    /** @type {?} */
    AutotabDirective.prototype.controlIndex;
    /** @type {?} */
    AutotabDirective.prototype.formElements;
    /** @type {?} */
    AutotabDirective.prototype.formElementIds;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/button/button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const COMPONENT_CLASS$1 = 'dlg-button';
class ButtonComponent {
    constructor() {
        this.attrType = 'button';
        this.classList = '';
        this.customClasses = '';
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set theme(theme) {
        this.customClasses += ` ${COMPONENT_CLASS$1}--${theme}`;
    }
    /**
     * @param {?} size
     * @return {?}
     */
    set size(size) {
        this.customClasses += ` ${COMPONENT_CLASS$1}--${size}`;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.classList =
            `${COMPONENT_CLASS$1} ${this.classList} ${this.customClasses}`
                .replace(/  +/g, ' ')
                .trim();
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["button", "dlg-button", ""]], hostVars: 3, hostBindings: function ButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("type", ctx.attrType);
        ɵngcc0.ɵɵclassMap(ctx.classList);
    } }, inputs: { classList: ["class", "classList"], theme: "theme", size: "size" }, attrs: _c2, ngContentSelectors: _c0, decls: 1, vars: 0, template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
ButtonComponent.propDecorators = {
    attrType: [{ type: HostBinding, args: ['attr.type',] }],
    classList: [{ type: HostBinding, args: ['class',] }, { type: Input, args: ['class',] }],
    theme: [{ type: Input }],
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'button[dlg-button]',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { attrType: [{
            type: HostBinding,
            args: ['attr.type']
        }], classList: [{
            type: HostBinding,
            args: ['class']
        }, {
            type: Input,
            args: ['class']
        }], theme: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    ButtonComponent.prototype.attrType;
    /** @type {?} */
    ButtonComponent.prototype.classList;
    /** @type {?} */
    ButtonComponent.prototype.customClasses;
}
class ButtonAnchorComponent extends ButtonComponent {
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    set disabled(isDisabled) {
        this.isDisabled = isDisabled ? isDisabled : null;
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this.isDisabled;
    }
    /**
     * @return {?}
     */
    get attrAriaDisabled() {
        return this.disabled ? this.disabled.toString() : null;
    }
    /**
     * @return {?}
     */
    get attrTabIndex() {
        return this.disabled ? -1 : null;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    clickEvent(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    }
}
ButtonAnchorComponent.ɵfac = /*@__PURE__*/ function () { let ɵButtonAnchorComponent_BaseFactory; return function ButtonAnchorComponent_Factory(t) { return (ɵButtonAnchorComponent_BaseFactory || (ɵButtonAnchorComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ButtonAnchorComponent)))(t || ButtonAnchorComponent); }; }();
ButtonAnchorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonAnchorComponent, selectors: [["a", "dlg-button", ""]], hostVars: 3, hostBindings: function ButtonAnchorComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ButtonAnchorComponent_click_HostBindingHandler($event) { return ctx.clickEvent($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled)("aria-disabled", ctx.attrAriaDisabled)("tabindex", ctx.attrTabIndex);
    } }, inputs: { disabled: "disabled" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c2, ngContentSelectors: _c0, decls: 1, vars: 0, template: function ButtonAnchorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
ButtonAnchorComponent.propDecorators = {
    disabled: [{ type: HostBinding, args: ['attr.disabled',] }, { type: Input }],
    attrAriaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    attrTabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    clickEvent: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonAnchorComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'a[dlg-button]',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { disabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }, {
            type: Input
        }], attrAriaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], attrTabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    clickEvent: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
if (false) {
    /** @type {?} */
    ButtonAnchorComponent.prototype.isDisabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/calendar/calendar.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const WEEKDAYS_SHORT = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
/** @type {?} */
const MONTHS_SHORT = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
/** @type {?} */
const MONTHS_FULL = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/calendar/calendar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgbDatepickerI18nCustom extends NgbDatepickerI18n {
    /**
     * @param {?} weekday
     * @return {?}
     */
    getWeekdayLabel(weekday) {
        return WEEKDAYS_SHORT[weekday - 1];
    }
    /**
     * @param {?} month
     * @return {?}
     */
    getMonthShortName(month) {
        return MONTHS_SHORT[month - 1];
    }
    /**
     * @param {?} month
     * @return {?}
     */
    getMonthFullName(month) {
        return MONTHS_FULL[month - 1];
    }
    /**
     * @param {?} date
     * @return {?}
     */
    getDayAriaLabel(date) {
        return `${date.year}-${this.getMonthFullName(date.month)}-${date.day}`;
    }
    /**
     * @param {?} weekday
     * @return {?}
     */
    getWeekdayShortName(weekday) {
        return WEEKDAYS_SHORT[weekday - 1];
    }
    /**
     * @param {?} date
     * @return {?}
     */
    getMonthLabel(date) {
        return MONTHS_FULL[date.month - 1];
    }
}
NgbDatepickerI18nCustom.ɵfac = /*@__PURE__*/ function () { let ɵNgbDatepickerI18nCustom_BaseFactory; return function NgbDatepickerI18nCustom_Factory(t) { return (ɵNgbDatepickerI18nCustom_BaseFactory || (ɵNgbDatepickerI18nCustom_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NgbDatepickerI18nCustom)))(t || NgbDatepickerI18nCustom); }; }();
NgbDatepickerI18nCustom.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgbDatepickerI18nCustom, factory: NgbDatepickerI18nCustom.ɵfac, providedIn: 'root' });
/** @nocollapse */ NgbDatepickerI18nCustom.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgbDatepickerI18nCustom_Factory() { return new NgbDatepickerI18nCustom(); }, token: NgbDatepickerI18nCustom, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgbDatepickerI18nCustom, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
class CalendarComponent {
    constructor() {
        this.subscription = new Subscription();
        this.analyticsComponentPrefix = '';
    }
    /**
     * @return {?}
     */
    get dateArray() {
        return this.formArray;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    set dateArray(date) {
        this.formArray = date;
        this.selectedDate = new NgbDate(parseInt(date.controls[2].value, 10), parseInt(date.controls[1].value, 10), parseInt(date.controls[0].value, 10));
    }
    /**
     * @param {?} date
     * @return {?}
     */
    selectedDateOnChange(date) {
        this.dateArray.setValue([date.day, date.month, date.year]);
        this.dateArray.updateValueAndValidity();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.subscription = this.datePicker.changes.subscribe((/**
         * @param {?} comps
         * @return {?}
         */
        (comps) => {
            this.datePickerElement = comps.first;
            this.setCalendarNavigationAnalytics();
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @private
     * @return {?}
     */
    setCalendarNavigationAnalytics() {
        this.analyticsComponentPrefix = `${this.config.name}:DateCalendar:`;
        /** @type {?} */
        const nativeElement = this.datePickerElement
            ? this.datePickerElement.nativeElement
            : undefined;
        if (nativeElement) {
            /** @type {?} */
            const navRightButton = nativeElement.querySelector('.ngb-dp-arrow.right button');
            /** @type {?} */
            const navLeftButton = nativeElement.querySelector('.ngb-dp-arrow button');
            navRightButton.setAttribute('data-dlg-component-nav', '');
            navRightButton.setAttribute('data-analytics-link-name', `${this.analyticsComponentPrefix}Nav:NextMonth`);
            navLeftButton.setAttribute('data-dlg-component-nav', '');
            navLeftButton.setAttribute('data-analytics-link-name', `${this.analyticsComponentPrefix}Nav:PrevMonth`);
        }
    }
}
CalendarComponent.ɵfac = function CalendarComponent_Factory(t) { return new (t || CalendarComponent)(); };
CalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CalendarComponent, selectors: [["dlg-calendar"]], viewQuery: function CalendarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePicker = _t);
    } }, inputs: { dateArray: "dateArray", pastDaysEnabled: "pastDaysEnabled", futureDaysEnabled: "futureDaysEnabled", config: "config", minDate: "minDate", maxDate: "maxDate" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nCustom },
        ])], decls: 8, vars: 8, consts: [["id", "dlg-calendar-container"], ["dlgAutotab", "", 1, "datepicker-wrapper"], [1, "calendar-hint", 3, "innerHTML"], [1, "dlg-input"], ["datepicker", ""], ["navigation", "arrows", "outsideDays", "hidden", 3, "ngModel", "ngModelOptions", "maxDate", "minDate", "startDate", "dayTemplate", "ngModelChange"], ["calendarDayTemplate", ""], [1, "ngb-dp-day"], ["data-dlg-component-nav", "", 1, "btn-light"]], template: function CalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3, 4)(5, "ngb-datepicker", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function CalendarComponent_Template_ngb_datepicker_ngModelChange_5_listener($event) { return ctx.selectedDate = $event; })("ngModelChange", function CalendarComponent_Template_ngb_datepicker_ngModelChange_5_listener($event) { return ctx.selectedDateOnChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, CalendarComponent_ng_template_6_Template, 3, 10, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.config.hint.calendarHint, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.selectedDate)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(7, _c4))("maxDate", ctx.maxDate)("minDate", ctx.minDate)("startDate", ctx.selectedDate)("dayTemplate", _r1);
    } }, dependencies: [ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.NgbDatepicker, AutotabDirective], styles: [".dlg-date-calendar .ngb-dp-week-number,.dlg-date-calendar .ngb-dp-weekday{font-style:normal}.dlg-date-calendar .ngb-dp-arrow-btn:focus{outline:0}.dlg-date-calendar .ngb-dp-months div.bg-primary{border-radius:50%}.dlg-date-calendar .ngb-dp-months{background-color:#f6f6f6}.dlg-date-calendar .ngb-dp-months .ngb-dp-weekdays{border-bottom:none}.dlg-date-calendar .ngb-dp-week{background-color:#fff;margin:.35rem 0;flex:1 0 1%;width:450px}.dlg-date-calendar .ngb-dp-week:not(:first-child){padding:.35rem}.dlg-date-calendar .ngb-dp-week:first-child{height:4rem;margin:0}.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-weekday{height:4rem}.dlg-date-calendar .ngb-dp-week:not(.ngb-dp-weekdays){margin-top:0}.dlg-date-calendar .ngb-dp-week .ngb-dp-weekday{color:#000;font-weight:700}.dlg-date-calendar .ngb-dp-month .ngb-dp-day,.dlg-date-calendar .ngb-dp-month .ngb-dp-weekday,.dlg-date-calendar .ngb-dp-week .ngb-dp-day,.dlg-date-calendar .ngb-dp-week .ngb-dp-weekday,.dlg-date-calendar ngb-datepicker .ngb-dp-day,.dlg-date-calendar ngb-datepicker .ngb-dp-weekday{width:2.5rem;height:2.5rem;text-align:center;display:flex;justify-content:center;align-items:center;flex:1 0 1%}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div,.dlg-date-calendar .ngb-dp-week .ngb-dp-day div,.dlg-date-calendar ngb-datepicker .ngb-dp-day div{width:2.5rem;height:2.5rem;line-height:2.5rem}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div.outside,.dlg-date-calendar .ngb-dp-week .ngb-dp-day div.outside,.dlg-date-calendar ngb-datepicker .ngb-dp-day div.outside{opacity:.5}.dlg-date-calendar .ngb-dp-header{background-color:#fff;padding:.35rem;height:3.5rem}.dlg-date-calendar .ngb-dp-header div{height:3rem;line-height:3rem}.dlg-date-calendar .ngb-dp-header .ngb-dp-month-name{font-size:18px}.dlg-date-calendar .datepicker-wrapper{margin-right:8px}.dlg-date-calendar .datepicker-wrapper .calendar-hint{padding:30px 30px 20px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p{margin-bottom:5px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p:last-child{margin-bottom:0}.dlg-date-calendar .dlg-input{display:flex;justify-content:center;flex:1 0 1%;margin-bottom:30px}.dlg-date-calendar .dlg-input ngb-datepicker{border:none}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation button{cursor:pointer}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation button[disabled]{cursor:auto;color:rgba(16,16,16,.3)}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation .ngb-dp-navigation-chevron::before{width:.65rem;height:.65rem}@media screen and (max-width:639px){.dlg-date-calendar .ngb-dp-week{background-color:#fff;margin:.35rem 0;padding:.35rem;display:flex;max-width:25rem;width:100%}.dlg-date-calendar .ngb-dp-week:first-child{margin-top:0;padding:0;height:3rem}.dlg-date-calendar .ngb-dp-header,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-day,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-day div,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-weekday{height:3rem}.dlg-date-calendar .ngb-dp-header div{height:2.5rem;line-height:2.5rem}.dlg-date-calendar .ngb-dp-month,.dlg-date-calendar ngb-datepicker{display:block;max-width:25rem;width:100%}.dlg-date-calendar .ngb-dp-month .ngb-dp-day,.dlg-date-calendar .ngb-dp-month .ngb-dp-weekday,.dlg-date-calendar ngb-datepicker .ngb-dp-day,.dlg-date-calendar ngb-datepicker .ngb-dp-weekday{width:100%;text-align:center}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div,.dlg-date-calendar ngb-datepicker .ngb-dp-day div{margin:0 .35rem}.dlg-date-calendar ngb-datepicker{min-height:340px}.dlg-date-calendar .ngb-dp-month,.dlg-date-calendar .ngb-dp-week,.dlg-date-calendar ngb-datepicker{max-width:360px;min-width:345px}.dlg-date-calendar .datepicker-wrapper{max-width:360px;width:100%}.dlg-date-calendar .datepicker-wrapper .dlg-input{margin-bottom:20px}.dlg-date-calendar .datepicker-wrapper .calendar-hint{padding:20px 10px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p{display:inline}}"], encapsulation: 2 });
CalendarComponent.propDecorators = {
    pastDaysEnabled: [{ type: Input }],
    futureDaysEnabled: [{ type: Input }],
    config: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    dateArray: [{ type: Input }],
    datePicker: [{ type: ViewChildren, args: ['datepicker',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CalendarComponent, [{
        type: Component,
        args: [{ selector: 'dlg-calendar', template: "<div id=\"dlg-calendar-container\">\n  <div class=\"datepicker-wrapper\" dlgAutotab>\n    <div class=\"calendar-hint\" [innerHTML]=\"config.hint.calendarHint\"></div>\n    <div class=\"dlg-input\" #datepicker>\n      <ngb-datepicker\n        [(ngModel)]=\"selectedDate\"\n        (ngModelChange)=\"selectedDateOnChange($event)\"\n        [ngModelOptions]=\"{ standalone: true }\"\n        [maxDate]=\"maxDate\"\n        [minDate]=\"minDate\"\n        [startDate]=\"selectedDate\"\n        navigation=\"arrows\"\n        outsideDays=\"hidden\"\n        [dayTemplate]=\"calendarDayTemplate\"></ngb-datepicker>\n      <ng-template\n        #calendarDayTemplate\n        let-date=\"date\"\n        let-focused=\"focused\"\n        let-selected=\"selected\"\n        let-disabled=\"disabled\">\n        <div class=\"ngb-dp-day\">\n          <div\n            class=\"btn-light\"\n            [class.focused]=\"focused\"\n            [class.bg-primary]=\"selected\"\n            [class.text-muted]=\"disabled\"\n            [class.outside]=\"disabled\"\n            [attr.data-analytics-link-name]=\"\n              analyticsComponentPrefix + 'DaySelected'\n            \"\n            data-dlg-component-nav>\n            {{ date.day }}\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</div>\n", encapsulation: ViewEncapsulation.None, providers: [
                    { provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nCustom },
                ], styles: [".dlg-date-calendar .ngb-dp-week-number,.dlg-date-calendar .ngb-dp-weekday{font-style:normal}.dlg-date-calendar .ngb-dp-arrow-btn:focus{outline:0}.dlg-date-calendar .ngb-dp-months div.bg-primary{border-radius:50%}.dlg-date-calendar .ngb-dp-months{background-color:#f6f6f6}.dlg-date-calendar .ngb-dp-months .ngb-dp-weekdays{border-bottom:none}.dlg-date-calendar .ngb-dp-week{background-color:#fff;margin:.35rem 0;flex:1 0 1%;width:450px}.dlg-date-calendar .ngb-dp-week:not(:first-child){padding:.35rem}.dlg-date-calendar .ngb-dp-week:first-child{height:4rem;margin:0}.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-weekday{height:4rem}.dlg-date-calendar .ngb-dp-week:not(.ngb-dp-weekdays){margin-top:0}.dlg-date-calendar .ngb-dp-week .ngb-dp-weekday{color:#000;font-weight:700}.dlg-date-calendar .ngb-dp-month .ngb-dp-day,.dlg-date-calendar .ngb-dp-month .ngb-dp-weekday,.dlg-date-calendar .ngb-dp-week .ngb-dp-day,.dlg-date-calendar .ngb-dp-week .ngb-dp-weekday,.dlg-date-calendar ngb-datepicker .ngb-dp-day,.dlg-date-calendar ngb-datepicker .ngb-dp-weekday{width:2.5rem;height:2.5rem;text-align:center;display:flex;justify-content:center;align-items:center;flex:1 0 1%}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div,.dlg-date-calendar .ngb-dp-week .ngb-dp-day div,.dlg-date-calendar ngb-datepicker .ngb-dp-day div{width:2.5rem;height:2.5rem;line-height:2.5rem}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div.outside,.dlg-date-calendar .ngb-dp-week .ngb-dp-day div.outside,.dlg-date-calendar ngb-datepicker .ngb-dp-day div.outside{opacity:.5}.dlg-date-calendar .ngb-dp-header{background-color:#fff;padding:.35rem;height:3.5rem}.dlg-date-calendar .ngb-dp-header div{height:3rem;line-height:3rem}.dlg-date-calendar .ngb-dp-header .ngb-dp-month-name{font-size:18px}.dlg-date-calendar .datepicker-wrapper{margin-right:8px}.dlg-date-calendar .datepicker-wrapper .calendar-hint{padding:30px 30px 20px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p{margin-bottom:5px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p:last-child{margin-bottom:0}.dlg-date-calendar .dlg-input{display:flex;justify-content:center;flex:1 0 1%;margin-bottom:30px}.dlg-date-calendar .dlg-input ngb-datepicker{border:none}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation button{cursor:pointer}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation button[disabled]{cursor:auto;color:rgba(16,16,16,.3)}.dlg-date-calendar .dlg-input ngb-datepicker ngb-datepicker-navigation .ngb-dp-navigation-chevron::before{width:.65rem;height:.65rem}@media screen and (max-width:639px){.dlg-date-calendar .ngb-dp-week{background-color:#fff;margin:.35rem 0;padding:.35rem;display:flex;max-width:25rem;width:100%}.dlg-date-calendar .ngb-dp-week:first-child{margin-top:0;padding:0;height:3rem}.dlg-date-calendar .ngb-dp-header,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-day,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-day div,.dlg-date-calendar .ngb-dp-week:first-child .ngb-dp-weekday{height:3rem}.dlg-date-calendar .ngb-dp-header div{height:2.5rem;line-height:2.5rem}.dlg-date-calendar .ngb-dp-month,.dlg-date-calendar ngb-datepicker{display:block;max-width:25rem;width:100%}.dlg-date-calendar .ngb-dp-month .ngb-dp-day,.dlg-date-calendar .ngb-dp-month .ngb-dp-weekday,.dlg-date-calendar ngb-datepicker .ngb-dp-day,.dlg-date-calendar ngb-datepicker .ngb-dp-weekday{width:100%;text-align:center}.dlg-date-calendar .ngb-dp-month .ngb-dp-day div,.dlg-date-calendar ngb-datepicker .ngb-dp-day div{margin:0 .35rem}.dlg-date-calendar ngb-datepicker{min-height:340px}.dlg-date-calendar .ngb-dp-month,.dlg-date-calendar .ngb-dp-week,.dlg-date-calendar ngb-datepicker{max-width:360px;min-width:345px}.dlg-date-calendar .datepicker-wrapper{max-width:360px;width:100%}.dlg-date-calendar .datepicker-wrapper .dlg-input{margin-bottom:20px}.dlg-date-calendar .datepicker-wrapper .calendar-hint{padding:20px 10px}.dlg-date-calendar .datepicker-wrapper .calendar-hint p{display:inline}}"] }]
    }], function () { return []; }, { dateArray: [{
            type: Input
        }], pastDaysEnabled: [{
            type: Input
        }], futureDaysEnabled: [{
            type: Input
        }], config: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], datePicker: [{
            type: ViewChildren,
            args: ['datepicker']
        }] }); })();
if (false) {
    /** @type {?} */
    CalendarComponent.prototype.pastDaysEnabled;
    /** @type {?} */
    CalendarComponent.prototype.futureDaysEnabled;
    /** @type {?} */
    CalendarComponent.prototype.config;
    /** @type {?} */
    CalendarComponent.prototype.minDate;
    /** @type {?} */
    CalendarComponent.prototype.maxDate;
    /** @type {?} */
    CalendarComponent.prototype.selectedDate;
    /** @type {?} */
    CalendarComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    CalendarComponent.prototype.formArray;
    /** @type {?} */
    CalendarComponent.prototype.datePicker;
    /** @type {?} */
    CalendarComponent.prototype.datePickerElement;
    /** @type {?} */
    CalendarComponent.prototype.analyticsComponentPrefix;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/checkbox/checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckboxComponent {
    constructor() {
        this.attrClass = 'dlg-checkbox';
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["dlg-checkbox"]], hostVars: 1, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.attrClass);
    } }, inputs: { name: "name", controlName: "controlName" }, ngContentSelectors: _c0, decls: 3, vars: 2, consts: [["type", "checkbox"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "input", 0);
        ɵngcc0.ɵɵelementStart(1, "label");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("for", ctx.name);
    } }, encapsulation: 2 });
CheckboxComponent.propDecorators = {
    name: [{ type: Input }],
    controlName: [{ type: Input }],
    attrClass: [{ type: HostBinding, args: ['attr.class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                /**
                 * @deprecated
                 */
                selector: 'dlg-checkbox',
                template: "<input type=\"checkbox\" [attr.id]=\"name\" />\n<label [attr.for]=\"name\">\n  <ng-content></ng-content>\n</label>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { attrClass: [{
            type: HostBinding,
            args: ['attr.class']
        }], name: [{
            type: Input
        }], controlName: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    CheckboxComponent.prototype.name;
    /** @type {?} */
    CheckboxComponent.prototype.controlName;
    /** @type {?} */
    CheckboxComponent.prototype.attrClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/animations/animations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const slideInOut = trigger('slideInOut', [
    state('in', style({ height: '*', opacity: 0 })),
    transition(':leave', [
        style({ height: '*', opacity: 1 }),
        group([
            animate(200, style({ height: 0 })),
            animate('200ms ease', style({ opacity: '0' })),
        ]),
    ]),
    transition(':enter', [
        style({ height: '0', opacity: 0 }),
        group([
            animate(200, style({ height: '*' })),
            animate('200ms 100ms ease', style({ opacity: '1' })),
        ]),
    ]),
]);
/** @type {?} */
const fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('0ms 100ms', style({ opacity: 1 })),
    ]),
    transition(':leave', [animate('0ms 100ms', style({ opacity: 0 }))]),
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/field/field.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const Layout = {
    Default: "default",
    A11y: "a11y",
};
/** @type {?} */
const hostClass = 'dlg-field';
class FieldComponent {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.namespace = '';
        this.isMasked = true;
        this.layout = Layout.Default;
        this.className = true;
        this.isFieldset = false;
        this.subscription = new Subscription();
        this.Layout = Layout;
    }
    /**
     * @param {?} type
     * @return {?}
     */
    set type(type) {
        this.elementRef.nativeElement.classList.add(`dlg-field--${type}`);
    }
    /**
     * @return {?}
     */
    getErrorMessage() {
        /** @type {?} */
        let error = '';
        if (this.control.dirty && this.control.invalid) {
            if (this.control['errors'] !== null &&
                typeof this.control['errors'] === 'object') {
                error = Object.keys(this.control['errors'])[0];
            }
        }
        if (error && this.config.validationMessages) {
            return this.config.validationMessages[error]
                ? this.config.validationMessages[error]
                : '';
        }
    }
    /**
     * @param {?} status
     * @return {?}
     */
    setClassNames(status) {
        if (status === 'INVALID') {
            this.elementRef.nativeElement.classList.add('has-error');
        }
        else {
            this.elementRef.nativeElement.classList.remove('has-error');
        }
        if (status === 'DISABLED') {
            this.elementRef.nativeElement.classList.add('is-disabled');
        }
        else {
            this.elementRef.nativeElement.classList.remove('is-disabled');
        }
    }
    /**
     * @param {?} isMasked
     * @return {?}
     */
    setMasking(isMasked) {
        /** @type {?} */
        const elements = [].slice.call(this.elementRef.nativeElement.querySelectorAll('input, select'));
        elements.forEach((/**
         * @param {?} element
         * @return {?}
         */
        element => {
            // tslint:disable-next-line:max-line-length quotemark
            /** @type {?} */
            const maskingElement = element.type === 'radio'
                ? this.elementRef.nativeElement.querySelector(`label[for='${element.id.replace(/'/g, "\\'")}']`)
                : element;
            if (isMasked) {
                this.renderer.setAttribute(maskingElement, 'data-recording-mask', '');
                this.renderer.removeAttribute(maskingElement, 'data-recording-unmask');
            }
            else {
                this.renderer.setAttribute(maskingElement, 'data-recording-unmask', '');
                this.renderer.removeAttribute(maskingElement, 'data-recording-mask');
            }
        }));
    }
    /**
     * @param {?} attrs
     * @return {?}
     */
    setOptionalAttributes(attrs) {
        /** @type {?} */
        const elements = Array.from(this.elementRef.nativeElement.querySelectorAll('input'));
        elements.forEach((/**
         * @param {?} element
         * @return {?}
         */
        element => {
            for (const attrKey in attrs) {
                if (attrs.hasOwnProperty(attrKey)) {
                    this.renderer.setAttribute(element, attrKey, attrs[attrKey]);
                }
            }
        }));
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        this.labelFor = this.config.name + this.namespace;
        this.setMasking(this.isMasked);
        this.elementRef.nativeElement.classList.add(`${hostClass}__layout--${this.layout}`);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.formGroup) {
            this.control = this.formGroup.get(this.config.name);
            this.errorMessage = this.getErrorMessage();
            this.subscription = this.control.statusChanges
                .pipe(filter((/**
             * @return {?}
             */
            () => this.control.dirty)))
                .subscribe((/**
             * @param {?} status
             * @return {?}
             */
            status => {
                this.errorMessage = this.getErrorMessage();
                this.setClassNames(status);
            }));
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.setMasking(this.isMasked);
        if (this.config && this.config.attrs) {
            this.setOptionalAttributes(this.config.attrs);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
FieldComponent.ɵfac = function FieldComponent_Factory(t) { return new (t || FieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
FieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FieldComponent, selectors: [["dlg-field"]], hostVars: 2, hostBindings: function FieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-field", ctx.className);
    } }, inputs: { namespace: "namespace", isMasked: ["masked", "isMasked"], layout: "layout", config: "config", formGroup: "formGroup" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 4, vars: 2, consts: [[4, "ngIf"], ["inputTemplate", ""], ["class", "dlg-field__label", 3, "id", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "dlg-field__label", 3, "id"], [3, "id", "hint", "isDisabled", 4, "ngIf"], ["class", "dlg-field__error", "aria-live", "assertive", 4, "ngIf"], ["class", "dlg-field__error", 3, "innerHTML", 4, "ngIf"], [3, "id", "hint", "isDisabled"], ["aria-live", "assertive", 1, "dlg-field__error"], [1, "hg-a11y-hidden"], [1, "dlg-field__message", 3, "innerHTML"], [1, "dlg-field__error", 3, "innerHTML"]], template: function FieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FieldComponent_div_0_Template, 3, 2, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FieldComponent_fieldset_1_Template, 3, 3, "fieldset", 0);
        ɵngcc0.ɵɵtemplate(2, FieldComponent_ng_template_2_Template, 4, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isFieldset);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFieldset);
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, HintComponent]; }, encapsulation: 2, data: { animation: [slideInOut, fadeInOut] } });
/** @nocollapse */
FieldComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
FieldComponent.propDecorators = {
    config: [{ type: Input }],
    formGroup: [{ type: Input }],
    namespace: [{ type: Input }],
    isMasked: [{ type: Input, args: ['masked',] }],
    layout: [{ type: Input }],
    className: [{ type: HostBinding, args: [`class.${hostClass}`,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-field',
                template: "<!-- Standard -->\n<div *ngIf=\"!isFieldset\">\n  <label\n    id=\"{{ labelFor + '-label' }}\"\n    *ngIf=\"config?.label\"\n    class=\"dlg-field__label\"\n    [attr.for]=\"labelFor\"\n    >{{ config.label }}</label\n  >\n  <ng-container *ngTemplateOutlet=\"inputTemplate\"></ng-container>\n</div>\n\n<!-- Fieldset -->\n<fieldset\n  *ngIf=\"isFieldset\"\n  [attr.aria-describedby]=\"config?.hint ? labelFor + '-hint' : null\">\n  <legend\n    *ngIf=\"config?.label\"\n    class=\"dlg-field__label\"\n    id=\"{{ labelFor + '-label' }}\">\n    {{ config.label }}\n  </legend>\n  <ng-container *ngTemplateOutlet=\"inputTemplate\"></ng-container>\n</fieldset>\n\n<ng-template #inputTemplate>\n  <dlg-hint\n    *ngIf=\"config?.hint\"\n    id=\"{{ labelFor + '-hint' }}\"\n    [hint]=\"config?.hint\"\n    [isDisabled]=\"control?.disabled\"></dlg-hint>\n\n  <div\n    *ngIf=\"errorMessage && layout === Layout.A11y\"\n    class=\"dlg-field__error\"\n    aria-live=\"assertive\"\n    @slideInOut>\n    <span class=\"hg-a11y-hidden\">Error:</span>\n    <span class=\"dlg-field__message\" [innerHTML]=\"errorMessage\"></span>\n  </div>\n\n  <ng-content></ng-content>\n  <div\n    *ngIf=\"errorMessage && layout === Layout.Default\"\n    class=\"dlg-field__error\"\n    [innerHTML]=\"errorMessage\"></div>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                animations: [slideInOut, fadeInOut]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { namespace: [{
            type: Input
        }], isMasked: [{
            type: Input,
            args: ['masked']
        }], layout: [{
            type: Input
        }], className: [{
            type: HostBinding,
            args: [`class.${hostClass}`]
        }], config: [{
            type: Input
        }], formGroup: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    FieldComponent.prototype.config;
    /** @type {?} */
    FieldComponent.prototype.formGroup;
    /** @type {?} */
    FieldComponent.prototype.namespace;
    /** @type {?} */
    FieldComponent.prototype.isMasked;
    /** @type {?} */
    FieldComponent.prototype.layout;
    /** @type {?} */
    FieldComponent.prototype.className;
    /** @type {?} */
    FieldComponent.prototype.isFieldset;
    /** @type {?} */
    FieldComponent.prototype.control;
    /** @type {?} */
    FieldComponent.prototype.errorMessage;
    /** @type {?} */
    FieldComponent.prototype.labelFor;
    /** @type {?} */
    FieldComponent.prototype.subscription;
    /** @type {?} */
    FieldComponent.prototype.Layout;
    /**
     * @type {?}
     * @private
     */
    FieldComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    FieldComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/checkbox/checkboxes.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const ControlType = {
    FormControl: "formControl",
    FormArray: "formArray",
};
class CheckboxesComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrClass = 'dlg-checkbox-group';
        this.ControlType = ControlType;
    }
    /**
     * @param {?} control
     * @return {?}
     */
    createControls(control) {
        if (control.length !== this.field.config.options.length) {
            for (let i = 0; i < this.field.config.options.length; i++) {
                control.insert(i, new FormControl({ value: '', disabled: control.disabled }));
            }
        }
    }
    /**
     * @param {?} option
     * @return {?}
     */
    displayAsValue(option) {
        return (/** @type {?} */ ((typeof option === 'object' && this.field.config.displayValue
            ? option[this.field.config.displayValue]
            : option)));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setFocus(event) {
        event.stopPropagation();
        /** @type {?} */
        const input = (/** @type {?} */ (event.target));
        input.focus();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const control = this.field.formGroup.get(this.field.config.name);
        if (control instanceof FormArray) {
            this.controlType = ControlType.FormArray;
            this.createControls((/** @type {?} */ (control)));
        }
        else {
            this.controlType = ControlType.FormControl;
        }
        this.field.isFieldset = true;
        this.field.type = 'checkbox';
    }
}
CheckboxesComponent.ɵfac = function CheckboxesComponent_Factory(t) { return new (t || CheckboxesComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
CheckboxesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxesComponent, selectors: [["dlg-checkboxes"]], hostVars: 1, hostBindings: function CheckboxesComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.attrClass);
    } }, decls: 3, vars: 3, consts: [[3, "formGroup"], [3, "formArrayName", 4, "ngIf"], [4, "ngIf"], [3, "formArrayName"], ["class", "dlg-checkbox", 4, "ngFor", "ngForOf"], [1, "dlg-checkbox"], ["type", "checkbox", 3, "formControlName", "value", "click"]], template: function CheckboxesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, CheckboxesComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, CheckboxesComponent_ng_container_2_Template, 5, 7, "ng-container", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.controlType === ctx.ControlType.FormArray);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.controlType === ctx.ControlType.FormControl);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName, ɵngcc2.FormArrayName], encapsulation: 2 });
/** @nocollapse */
CheckboxesComponent.ctorParameters = () => [
    { type: FieldComponent }
];
CheckboxesComponent.propDecorators = {
    attrClass: [{ type: HostBinding, args: ['attr.class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxesComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-checkboxes',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <ng-container\n    *ngIf=\"controlType === ControlType.FormArray\"\n    [formArrayName]=\"field.config.name\">\n    <div\n      *ngFor=\"let option of field.config.options; index as i\"\n      class=\"dlg-checkbox\">\n      <input\n        type=\"checkbox\"\n        [attr.id]=\"field.config.name + '-' + i\"\n        [attr.name]=\"field.config.name\"\n        [formControlName]=\"i\"\n        [value]=\"displayAsValue(option)\"\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \"\n        (click)=\"setFocus($event)\" />\n      <label [attr.for]=\"field.config.name + '-' + i\">{{\n        displayAsValue(option)\n      }}</label>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"controlType === ControlType.FormControl\">\n    <div class=\"dlg-checkbox\">\n      <input\n        type=\"checkbox\"\n        [attr.id]=\"field.labelFor\"\n        [attr.name]=\"field.labelFor\"\n        [formControlName]=\"field.config.name\"\n        [value]=\"field.config.options[0]\"\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \"\n        (click)=\"setFocus($event)\" />\n      <label [attr.for]=\"field.labelFor\">{{\n        displayAsValue(field.config.options[0])\n      }}</label>\n    </div>\n  </ng-container>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['attr.class']
        }] }); })();
if (false) {
    /** @type {?} */
    CheckboxesComponent.prototype.attrClass;
    /** @type {?} */
    CheckboxesComponent.prototype.controlType;
    /** @type {?} */
    CheckboxesComponent.prototype.ControlType;
    /** @type {?} */
    CheckboxesComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/datepicker/datepicker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DateChange() { }
if (false) {
    /** @type {?} */
    DateChange.prototype.e;
    /** @type {?} */
    DateChange.prototype.type;
}
class DatepickerComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.type = 'input';
        this.display = {
            days: true,
            months: true,
            years: true,
        };
        this.displayLabel = false;
        this.showMonthAsNumber = false;
        this.changed = new EventEmitter();
        this.days = [];
        this.months = [];
        this.years = [];
        this.prettyMonths = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    createControls(isDisabled) {
        if (this.control.length !== 3) {
            this.control.reset();
            for (const key of Object.keys([0, 1, 2])) {
                this.control.insert(parseInt(key, 10), new FormControl({ value: '', disabled: isDisabled }));
            }
        }
    }
    /**
     * @return {?}
     */
    createDays() {
        if (this.format && this.format['days']) {
            for (let i = this.format['days']['min']; i <= this.format['days']['max']; i++) {
                this.days.push(this.formatNumber(i));
            }
        }
        else {
            // Default
            for (let i = 1; i <= 31; i++) {
                this.days.push(this.formatNumber(i));
            }
        }
    }
    /**
     * @return {?}
     */
    createMonths() {
        if (this.format && this.format['months']) {
            for (let i = this.format['months']['min']; i <= this.format['months']['max']; i++) {
                this.months.push(this.formatNumber(i));
            }
        }
        else {
            for (let i = 1; i <= 12; i++) {
                this.months.push(this.formatNumber(i));
            }
        }
    }
    /**
     * @return {?}
     */
    createYears() {
        if (this.format && this.format['years']) {
            for (let i = this.format['years']['min']; i <= this.format['years']['max']; i++) {
                this.years.push(i.toString());
            }
        }
        else {
            for (let i = 1900; i <= new Date().getFullYear(); i++) {
                this.years.push(i.toString());
            }
        }
        this.years.reverse();
    }
    /**
     * @param {?} month
     * @return {?}
     */
    formatMonth(month) {
        return this.prettyMonths[month - 1];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.field.isFieldset = true;
        this.control = (/** @type {?} */ (this.field.formGroup.get(this.field.config.name)));
        this.createControls(this.control.disabled);
        this.createDays();
        this.createMonths();
        this.createYears();
    }
    /**
     * @param {?} e
     * @param {?} type
     * @return {?}
     */
    onChange(e, type) {
        this.changed.emit({ e, type });
    }
    /**
     * @private
     * @param {?} num
     * @return {?}
     */
    formatNumber(num) {
        return this.showMonthAsNumber
            ? num.toString().padStart(2, '0')
            : num.toString();
    }
}
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
DatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["dlg-datepicker"]], inputs: { type: "type", display: "display", displayLabel: "displayLabel", showMonthAsNumber: "showMonthAsNumber", format: "format", numericKeypad: "numericKeypad" }, outputs: { changed: "changed" }, decls: 4, vars: 4, consts: [[3, "formGroup"], ["dlgAutotab", "", 1, "dlg-datepicker", "dlg-select", "dlg-input", 3, "formArrayName"], [4, "ngIf"], ["dlg-input", "", "maxlength", "2", "placeholder", "DD", "autocomplete", "off", "formControlName", "0"], ["autotab", ""], ["dlg-input", "", "maxlength", "2", "formControlName", "1", "placeholder", "MM", "autocomplete", "off"], ["dlg-input", "", "minlength", "4", "maxlength", "4", "formControlName", "2", "placeholder", "YYYY", "autocomplete", "off"], [1, "date-container"], [3, "ngClass"], ["formControlName", "0", 1, "dlg-select", 3, "change"], ["value", "", "hidden", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["formControlName", "1", 1, "dlg-select", 3, "change"], ["formControlName", "2", 1, "dlg-select", 3, "change"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DatepickerComponent_ng_container_2_Template, 4, 3, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(3, DatepickerComponent_ng_container_3_Template, 5, 3, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formArrayName", ctx.field.config.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "input" || ctx.type === "number");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "select");
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.NgSelectOption, ɵngcc2.ɵNgSelectMultipleOption, ɵngcc2.DefaultValueAccessor, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.MinLengthValidator, ɵngcc2.MaxLengthValidator, ɵngcc2.PatternValidator, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName, ɵngcc2.FormArrayName, AutotabDirective], encapsulation: 2 });
/** @nocollapse */
DatepickerComponent.ctorParameters = () => [
    { type: FieldComponent }
];
DatepickerComponent.propDecorators = {
    type: [{ type: Input }],
    format: [{ type: Input }],
    numericKeypad: [{ type: Input }],
    display: [{ type: Input }],
    displayLabel: [{ type: Input }],
    showMonthAsNumber: [{ type: Input }],
    changed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-datepicker',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <div\n    class=\"dlg-datepicker dlg-select dlg-input\"\n    [formArrayName]=\"field.config.name\"\n    dlgAutotab>\n    <ng-container *ngIf=\"type === 'input' || type === 'number'\">\n      <ng-container *ngIf=\"display.days\">\n        <label [attr.for]=\"field.labelFor + '-day'\">Day</label>\n        <input\n          dlg-input\n          maxlength=\"2\"\n          [attr.type]=\"type\"\n          [attr.id]=\"field.labelFor + '-day'\"\n          [attr.name]=\"field.labelFor\"\n          placeholder=\"DD\"\n          autocomplete=\"off\"\n          #autotab\n          formControlName=\"0\"\n          [attr.inputmode]=\"numericKeypad ? 'numeric' : null\"\n          [attr.pattern]=\"numericKeypad ? '[0-9]*' : null\"\n          [attr.aria-describedby]=\"\n            field.config?.hint ? field.labelFor + '-hint' : null\n          \" />\n      </ng-container>\n      <ng-container *ngIf=\"display.months\">\n        <label [attr.for]=\"field.labelFor + '-month'\">Month</label>\n        <input\n          dlg-input\n          maxlength=\"2\"\n          [attr.type]=\"type\"\n          [attr.id]=\"field.labelFor + '-month'\"\n          [attr.name]=\"field.labelFor\"\n          formControlName=\"1\"\n          placeholder=\"MM\"\n          autocomplete=\"off\"\n          #autotab\n          [attr.inputmode]=\"numericKeypad ? 'numeric' : null\"\n          [attr.pattern]=\"numericKeypad ? '[0-9]*' : null\"\n          [attr.aria-describedby]=\"\n            field.config?.hint ? field.labelFor + '-hint' : null\n          \" />\n      </ng-container>\n      <ng-container *ngIf=\"display.years\">\n        <label [attr.for]=\"field.labelFor + '-year'\">Year</label>\n        <input\n          dlg-input\n          minlength=\"4\"\n          [attr.type]=\"type\"\n          [attr.id]=\"field.labelFor + '-year'\"\n          [attr.name]=\"field.labelFor\"\n          maxlength=\"4\"\n          formControlName=\"2\"\n          placeholder=\"YYYY\"\n          autocomplete=\"off\"\n          #autotab\n          [attr.inputmode]=\"numericKeypad ? 'numeric' : null\"\n          [attr.pattern]=\"numericKeypad ? '[0-9]*' : null\"\n          [attr.aria-describedby]=\"\n            field.config?.hint ? field.labelFor + '-hint' : null\n          \" />\n      </ng-container>\n    </ng-container>\n    <ng-container *ngIf=\"type === 'select'\">\n      <div class=\"date-container\">\n        <ng-container *ngIf=\"display.days\">\n          <div [ngClass]=\"displayLabel ? 'field-container' : ''\">\n            <label [attr.for]=\"field.labelFor + '-day'\">Day</label>\n            <select\n              class=\"dlg-select\"\n              formControlName=\"0\"\n              [attr.id]=\"field.labelFor + '-day'\"\n              [attr.name]=\"field.labelFor\"\n              [attr.aria-describedby]=\"\n                field.config?.hint ? field.labelFor + '-hint' : null\n              \"\n              (change)=\"onChange($event, 'day')\">\n              <option value=\"\" hidden>DD</option>\n              <option *ngFor=\"let option of days\" [ngValue]=\"option\">\n                {{ option }}\n              </option>\n            </select>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"display.months\">\n          <div [ngClass]=\"displayLabel ? 'field-container' : ''\">\n            <label [attr.for]=\"field.labelFor + '-month'\">Month</label>\n            <select\n              class=\"dlg-select\"\n              formControlName=\"1\"\n              [attr.id]=\"field.labelFor + '-month'\"\n              [attr.name]=\"field.labelFor\"\n              [attr.aria-describedby]=\"\n                field.config?.hint ? field.labelFor + '-hint' : null\n              \"\n              (change)=\"onChange($event, 'month')\">\n              <option value=\"\" hidden>MM</option>\n              <option *ngFor=\"let option of months\" [ngValue]=\"option\">\n                {{ showMonthAsNumber ? option : formatMonth(option) }}\n              </option>\n            </select>\n          </div>\n        </ng-container>\n        <ng-container *ngIf=\"display.years\">\n          <div [ngClass]=\"displayLabel ? 'field-container' : ''\">\n            <label [attr.for]=\"field.labelFor + '-year'\">Year</label>\n            <select\n              class=\"dlg-select\"\n              formControlName=\"2\"\n              [attr.id]=\"field.labelFor + '-year'\"\n              [attr.name]=\"field.labelFor\"\n              [attr.aria-describedby]=\"\n                field.config?.hint ? field.labelFor + '-hint' : null\n              \"\n              (change)=\"onChange($event, 'year')\">\n              <option value=\"\" hidden>YYYY</option>\n              <option *ngFor=\"let option of years\" [ngValue]=\"option\">\n                {{ option }}\n              </option>\n            </select>\n          </div>\n        </ng-container>\n      </div>\n    </ng-container>\n  </div>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { type: [{
            type: Input
        }], display: [{
            type: Input
        }], displayLabel: [{
            type: Input
        }], showMonthAsNumber: [{
            type: Input
        }], changed: [{
            type: Output
        }], format: [{
            type: Input
        }], numericKeypad: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DatepickerComponent.prototype.type;
    /** @type {?} */
    DatepickerComponent.prototype.format;
    /** @type {?} */
    DatepickerComponent.prototype.numericKeypad;
    /** @type {?} */
    DatepickerComponent.prototype.display;
    /** @type {?} */
    DatepickerComponent.prototype.displayLabel;
    /** @type {?} */
    DatepickerComponent.prototype.showMonthAsNumber;
    /** @type {?} */
    DatepickerComponent.prototype.changed;
    /** @type {?} */
    DatepickerComponent.prototype.control;
    /** @type {?} */
    DatepickerComponent.prototype.days;
    /** @type {?} */
    DatepickerComponent.prototype.months;
    /** @type {?} */
    DatepickerComponent.prototype.years;
    /** @type {?} */
    DatepickerComponent.prototype.prettyMonths;
    /** @type {?} */
    DatepickerComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/field/field-link.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldLinkComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrClass = 'dlg-field__link';
        this.attrRole = 'none';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.attrId = `${this.field.labelFor}-field-link`;
    }
}
FieldLinkComponent.ɵfac = function FieldLinkComponent_Factory(t) { return new (t || FieldLinkComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
FieldLinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FieldLinkComponent, selectors: [["dlg-field-link"]], hostVars: 3, hostBindings: function FieldLinkComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.attrClass)("role", ctx.attrRole)("id", ctx.attrId);
    } }, ngContentSelectors: _c0, decls: 2, vars: 1, template: function FieldLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.field.labelFor + "-field-link");
    } }, encapsulation: 2 });
/** @nocollapse */
FieldLinkComponent.ctorParameters = () => [
    { type: FieldComponent }
];
FieldLinkComponent.propDecorators = {
    attrId: [{ type: HostBinding, args: ['attr.id',] }],
    attrClass: [{ type: HostBinding, args: ['attr.class',] }],
    attrRole: [{ type: HostBinding, args: ['attr.role',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldLinkComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-field-link',
                template: "<button [attr.aria-labelledby]=\"field.labelFor + '-field-link'\">\n  <ng-content></ng-content>\n</button>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['attr.class']
        }], attrRole: [{
            type: HostBinding,
            args: ['attr.role']
        }], attrId: [{
            type: HostBinding,
            args: ['attr.id']
        }] }); })();
if (false) {
    /** @type {?} */
    FieldLinkComponent.prototype.attrId;
    /** @type {?} */
    FieldLinkComponent.prototype.attrClass;
    /** @type {?} */
    FieldLinkComponent.prototype.attrRole;
    /** @type {?} */
    FieldLinkComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/field/field-prefix.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldPrefixComponent {
    constructor() {
        this.attrClass = 'dlg-field__prefix';
    }
}
FieldPrefixComponent.ɵfac = function FieldPrefixComponent_Factory(t) { return new (t || FieldPrefixComponent)(); };
FieldPrefixComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FieldPrefixComponent, selectors: [["dlg-field-prefix"]], hostVars: 1, hostBindings: function FieldPrefixComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.attrClass);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function FieldPrefixComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
FieldPrefixComponent.propDecorators = {
    attrClass: [{ type: HostBinding, args: ['attr.class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldPrefixComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-field-prefix',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { attrClass: [{
            type: HostBinding,
            args: ['attr.class']
        }] }); })();
if (false) {
    /** @type {?} */
    FieldPrefixComponent.prototype.attrClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/hint/hint.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Hint {
}
if (false) {
    /** @type {?} */
    Hint.prototype.text;
    /** @type {?} */
    Hint.prototype.moreText;
    /** @type {?} */
    Hint.prototype.readMoreLabel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/hint/hint.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HintComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.className = true;
        this.isDisabled = false;
        this.abbreviated = false;
        this.isExpanded = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.abbreviated = this.field.layout !== Layout.A11y;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    toggle(e) {
        e.preventDefault();
        if (!this.isDisabled) {
            this.isExpanded = !this.isExpanded;
        }
    }
}
HintComponent.ɵfac = function HintComponent_Factory(t) { return new (t || HintComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
HintComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HintComponent, selectors: [["dlg-hint"]], hostVars: 2, hostBindings: function HintComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-hint", ctx.className);
    } }, inputs: { isDisabled: "isDisabled", hint: "hint" }, decls: 3, vars: 3, consts: [["class", "dlg-hint__text", 3, "innerHTML", 4, "ngIf"], ["class", "dlg-hint__toggle", 3, "dlg-hint__toggle--expanded", "disabled", "click", 4, "ngIf"], ["class", "dlg-hint__text", "role", "region", 3, "innerHTML", 4, "ngIf"], [1, "dlg-hint__text", 3, "innerHTML"], [1, "dlg-hint__toggle", 3, "disabled", "click"], [1, "hg-a11y-hidden"], ["role", "region", 1, "dlg-hint__text", 3, "innerHTML"]], template: function HintComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HintComponent_div_0_Template, 1, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HintComponent_button_1_Template, 4, 7, "button", 1);
        ɵngcc0.ɵɵtemplate(2, HintComponent_div_2_Template, 1, 2, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hint.text);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hint.moreText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hint.moreText);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2 });
/** @nocollapse */
HintComponent.ctorParameters = () => [
    { type: FieldComponent }
];
HintComponent.propDecorators = {
    className: [{ type: HostBinding, args: ['class.dlg-hint',] }],
    hint: [{ type: Input }],
    isDisabled: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HintComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-hint',
                template: "<div *ngIf=\"hint.text\" class=\"dlg-hint__text\" [innerHTML]=\"hint.text\"></div>\n<button\n  class=\"dlg-hint__toggle\"\n  *ngIf=\"hint.moreText\"\n  (click)=\"toggle($event)\"\n  [class.dlg-hint__toggle--expanded]=\"isExpanded\"\n  [disabled]=\"isDisabled\"\n  [attr.aria-expanded]=\"isExpanded\"\n  [attr.aria-controls]=\"field.config.name + '-hint'\">\n  {{\n    hint.readMoreLabel\n      ? hint.readMoreLabel\n      : isExpanded\n      ? 'Less ' + (abbreviated ? 'info' : 'information')\n      : 'More ' + (abbreviated ? 'info' : 'information')\n  }}\n  <span class=\"hg-a11y-hidden\">on {{ field.config.label }}</span>\n</button>\n<div\n  [attr.id]=\"field.config.name + '-hint'\"\n  class=\"dlg-hint__text\"\n  *ngIf=\"hint.moreText\"\n  [innerHTML]=\"hint.moreText\"\n  role=\"region\"></div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { className: [{
            type: HostBinding,
            args: ['class.dlg-hint']
        }], isDisabled: [{
            type: Input
        }], hint: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    HintComponent.prototype.className;
    /** @type {?} */
    HintComponent.prototype.hint;
    /** @type {?} */
    HintComponent.prototype.isDisabled;
    /** @type {?} */
    HintComponent.prototype.abbreviated;
    /** @type {?} */
    HintComponent.prototype.isExpanded;
    /** @type {?} */
    HintComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/icon/icon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IconComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.className = true;
    }
    /**
     * @param {?} position
     * @return {?}
     */
    set positioning(position) {
        this.elementRef.nativeElement.classList.add('is-' + position);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.position) {
            this.positioning = this.position;
        }
    }
}
IconComponent.ɵfac = function IconComponent_Factory(t) { return new (t || IconComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
IconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconComponent, selectors: [["dlg-icon"]], hostVars: 2, hostBindings: function IconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-icon", ctx.className);
    } }, inputs: { name: "name", position: "position" }, decls: 2, vars: 1, consts: [["role", "none", "focusable", "false"]], template: function IconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "use");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("href", "#" + ctx.name, null, "xlink");
    } }, styles: [".dlg-icon{display:inline-block;width:24px;height:24px;vertical-align:middle;line-height:100%;fill:currentColor}.dlg-icon svg{width:100%;height:100%}dlg-button .dlg-icon{margin-top:-4px}.dlg-icon.is-before{margin-right:4px;margin-left:-8px}.dlg-icon.is-after{margin-right:-8px;margin-left:4px}"], encapsulation: 2 });
/** @nocollapse */
IconComponent.ctorParameters = () => [
    { type: ElementRef }
];
IconComponent.propDecorators = {
    name: [{ type: Input }],
    position: [{ type: Input }],
    className: [{ type: HostBinding, args: ['class.dlg-icon',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconComponent, [{
        type: Component,
        args: [{ selector: 'dlg-icon', template: "<svg role=\"none\" focusable=\"false\">\n  <use [attr.xlink:href]=\"'#' + name\" />\n</svg>\n", encapsulation: ViewEncapsulation.None, styles: [".dlg-icon{display:inline-block;width:24px;height:24px;vertical-align:middle;line-height:100%;fill:currentColor}.dlg-icon svg{width:100%;height:100%}dlg-button .dlg-icon{margin-top:-4px}.dlg-icon.is-before{margin-right:4px;margin-left:-8px}.dlg-icon.is-after{margin-right:-8px;margin-left:4px}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { className: [{
            type: HostBinding,
            args: ['class.dlg-icon']
        }], name: [{
            type: Input
        }], position: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    IconComponent.prototype.name;
    /** @type {?} */
    IconComponent.prototype.position;
    /** @type {?} */
    IconComponent.prototype.className;
    /**
     * @type {?}
     * @private
     */
    IconComponent.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/input-group/input-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputGroupComponent {
    constructor() {
        this.className = true;
    }
}
InputGroupComponent.ɵfac = function InputGroupComponent_Factory(t) { return new (t || InputGroupComponent)(); };
InputGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputGroupComponent, selectors: [["dlg-input-group"]], hostVars: 2, hostBindings: function InputGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-input-group", ctx.className);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function InputGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
InputGroupComponent.propDecorators = {
    className: [{ type: HostBinding, args: ['class.dlg-input-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputGroupComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-input-group',
                template: '<ng-content></ng-content>'
            }]
    }], function () { return []; }, { className: [{
            type: HostBinding,
            args: ['class.dlg-input-group']
        }] }); })();
if (false) {
    /** @type {?} */
    InputGroupComponent.prototype.className;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/input/input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* tslint:disable */
/** @type {?} */
let AUTOCOMPLETE_TYPES;
/* tslint:enable */
class InputComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrAutocomplete = 'off';
        this.placeholder = '';
        this.attrType = 'text';
        this.blurred = new EventEmitter();
        this.attrClass = 'dlg-input';
    }
    /**
     * @param {?} isAutocomplete
     * @return {?}
     */
    set autocomplete(isAutocomplete) {
        this.attrAutocomplete =
            isAutocomplete === true
                ? 'on'
                : isAutocomplete === false
                    ? 'off'
                    : isAutocomplete;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.placeholder = this.field.config.placeholder || '';
        if (this.attrType === 'hidden') {
            this.field.type = 'hidden';
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onBlur(e) {
        this.blurred.emit(e);
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["dlg-input"]], hostVars: 2, hostBindings: function InputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.attrClass);
    } }, inputs: { attrType: ["type", "attrType"], autocomplete: "autocomplete", attrMaxLength: ["maxlength", "attrMaxLength"] }, outputs: { blurred: "blurred" }, decls: 2, vars: 9, consts: [[3, "formGroup"], [3, "placeholder", "id", "formControlName", "blur"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("blur", function InputComponent_Template_input_blur_1_listener($event) { return ctx.onBlur($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("id", ctx.field.labelFor)("formControlName", ctx.field.config.name);
        ɵngcc0.ɵɵattribute("type", ctx.attrType)("maxlength", ctx.attrMaxLength)("autocomplete", ctx.attrAutocomplete)("aria-invalid", (ctx.field.control == null ? null : ctx.field.control.dirty) ? ctx.field.control == null ? null : ctx.field.control.invalid : false)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
    } }, dependencies: [ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.MaxLengthValidator, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName], encapsulation: 2 });
/** @nocollapse */
InputComponent.ctorParameters = () => [
    { type: FieldComponent }
];
InputComponent.propDecorators = {
    attrMaxLength: [{ type: Input, args: ['maxlength',] }],
    attrType: [{ type: Input, args: ['type',] }],
    blurred: [{ type: Output }],
    autocomplete: [{ type: Input }],
    attrClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-input',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <input\n    (blur)=\"onBlur($event)\"\n    [placeholder]=\"placeholder\"\n    [id]=\"field.labelFor\"\n    [formControlName]=\"field.config.name\"\n    [attr.type]=\"attrType\"\n    [attr.maxlength]=\"attrMaxLength\"\n    [attr.autocomplete]=\"attrAutocomplete\"\n    [attr.aria-invalid]=\"field.control?.dirty ? field.control?.invalid : false\"\n    [attr.aria-describedby]=\"\n      field.config?.hint ? field.labelFor + '-hint' : null\n    \" />\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrType: [{
            type: Input,
            args: ['type']
        }], blurred: [{
            type: Output
        }], attrClass: [{
            type: HostBinding,
            args: ['class']
        }], autocomplete: [{
            type: Input
        }], attrMaxLength: [{
            type: Input,
            args: ['maxlength']
        }] }); })();
if (false) {
    /** @type {?} */
    InputComponent.prototype.attrAutocomplete;
    /** @type {?} */
    InputComponent.prototype.placeholder;
    /** @type {?} */
    InputComponent.prototype.attrMaxLength;
    /** @type {?} */
    InputComponent.prototype.attrType;
    /** @type {?} */
    InputComponent.prototype.blurred;
    /** @type {?} */
    InputComponent.prototype.attrClass;
    /** @type {?} */
    InputComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal/modal-ref.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalRef {
    constructor() {
        this.closed = new Subject();
        this.closed$ = this.closed.asObservable();
    }
    /**
     * @param {?=} result
     * @return {?}
     */
    close(result) {
        this.closed.next(result);
        this.closed.complete();
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ModalRef.prototype.closed;
    /** @type {?} */
    ModalRef.prototype.closed$;
    /** @type {?} */
    ModalRef.prototype.component;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal/modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MODAL_CANCEL = 'cancel';
class ModalComponent {
    /**
     * @param {?} cdr
     * @param {?} componentFactoryResolver
     * @param {?} modalRef
     */
    constructor(cdr, componentFactoryResolver, modalRef) {
        this.cdr = cdr;
        this.componentFactoryResolver = componentFactoryResolver;
        this.modalRef = modalRef;
        this.ariaLabelledBy = null;
        this.ariaDescribedBy = null;
        this.animations = false;
        this.disablePassiveClose = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    keyup(event) {
        if (event.code.toLowerCase() === 'escape' && !this.disablePassiveClose) {
            this.close();
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    click(event) {
        if (event.target === this.modalBackdrop.nativeElement &&
            !this.disablePassiveClose) {
            this.close();
        }
    }
    /**
     * @param {?} component
     * @return {?}
     */
    createChildComponent(component) {
        /** @type {?} */
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        /** @type {?} */
        const viewContainerRef = this.location;
        viewContainerRef.clear();
        this.childComponentRef = viewContainerRef.createComponent(componentFactory);
        const { data } = this.childComponentRef.instance;
        this.ariaLabelledBy =
            data && data.accessibility && data.accessibility.ariaLabelledBy;
        this.ariaDescribedBy =
            data && data.accessibility && data.accessibility.ariaDescribedBy;
        this.disablePassiveClose = data && data.disablePassiveClose;
        this.animations = data && data.animations;
    }
    /**
     * @return {?}
     */
    close() {
        this.modalRef.close(MODAL_CANCEL);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.createChildComponent(this.componentType);
        this.cdr.detectChanges();
        this.modal.nativeElement.focus();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.childComponentRef.destroy();
    }
}
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ModalRef)); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["dlg-modal"]], viewQuery: function ModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c6, 7);
        ɵngcc0.ɵɵviewQuery(_c7, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.location = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modal = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalBackdrop = _t.first);
    } }, hostBindings: function ModalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup", function ModalComponent_keyup_HostBindingHandler($event) { return ctx.keyup($event); }, false, ɵngcc0.ɵɵresolveDocument)("click", function ModalComponent_click_HostBindingHandler($event) { return ctx.click($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 6, vars: 6, consts: [["aria-hidden", "true", 1, "dlg-modal-backdrop"], ["modalBackdrop", ""], ["role", "dialog", "aria-modal", "true", "cdkTrapFocus", "", "tabindex", "0", 1, "dlg-modal"], ["modal", ""], ["childComponentLocation", ""]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵelementContainer(4, null, 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@fadeInOut", undefined)("@.disabled", !ctx.animations);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("@fadeInOut", undefined)("@.disabled", !ctx.animations);
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledBy)("aria-describedby", ctx.ariaDescribedBy);
    } }, dependencies: [ɵngcc4.CdkTrapFocus], encapsulation: 2, data: { animation: [fadeInOut] }, changeDetection: 0 });
/** @nocollapse */
ModalComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ComponentFactoryResolver },
    { type: ModalRef }
];
ModalComponent.propDecorators = {
    location: [{ type: ViewChild, args: ['childComponentLocation', { read: ViewContainerRef, static: true },] }],
    modal: [{ type: ViewChild, args: ['modal', { static: true },] }],
    modalBackdrop: [{ type: ViewChild, args: ['modalBackdrop', { static: true },] }],
    keyup: [{ type: HostListener, args: ['document:keyup', ['$event'],] }],
    click: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-modal',
                template: "<div\n  @fadeInOut\n  [@.disabled]=\"!animations\"\n  class=\"dlg-modal-backdrop\"\n  #modalBackdrop\n  aria-hidden=\"true\"></div>\n<div\n  class=\"dlg-modal\"\n  role=\"dialog\"\n  aria-modal=\"true\"\n  cdkTrapFocus\n  tabindex=\"0\"\n  #modal\n  @fadeInOut\n  [@.disabled]=\"!animations\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\"\n  [attr.aria-describedby]=\"ariaDescribedBy\">\n  <ng-container #childComponentLocation></ng-container>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [fadeInOut]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ModalRef }]; }, { 
    /**
     * @param {?} event
     * @return {?}
     */
    keyup: [{
            type: HostListener,
            args: ['document:keyup', ['$event']]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    click: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], location: [{
            type: ViewChild,
            args: ['childComponentLocation', { read: ViewContainerRef, static: true }]
        }], modal: [{
            type: ViewChild,
            args: ['modal', { static: true }]
        }], modalBackdrop: [{
            type: ViewChild,
            args: ['modalBackdrop', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    ModalComponent.prototype.componentType;
    /** @type {?} */
    ModalComponent.prototype.childComponentRef;
    /** @type {?} */
    ModalComponent.prototype.ariaLabelledBy;
    /** @type {?} */
    ModalComponent.prototype.ariaDescribedBy;
    /** @type {?} */
    ModalComponent.prototype.animations;
    /** @type {?} */
    ModalComponent.prototype.disablePassiveClose;
    /** @type {?} */
    ModalComponent.prototype.location;
    /** @type {?} */
    ModalComponent.prototype.modal;
    /** @type {?} */
    ModalComponent.prototype.modalBackdrop;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.cdr;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.componentFactoryResolver;
    /** @type {?} */
    ModalComponent.prototype.modalRef;
}
class ModalActionsComponent {
    constructor() {
        this.attrClass = 'dlg-modal__actions';
    }
}
ModalActionsComponent.ɵfac = function ModalActionsComponent_Factory(t) { return new (t || ModalActionsComponent)(); };
ModalActionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalActionsComponent, selectors: [["dlg-modal-actions"]], hostVars: 2, hostBindings: function ModalActionsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.attrClass);
    } }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function ModalActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
ModalActionsComponent.propDecorators = {
    attrClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalActionsComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-modal-actions',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { attrClass: [{
            type: HostBinding,
            args: ['class']
        }] }); })();
if (false) {
    /** @type {?} */
    ModalActionsComponent.prototype.attrClass;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal/modal-injector.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalInjector {
    /**
     * @param {?} parentInjector
     * @param {?} customTokens
     */
    constructor(parentInjector, customTokens) {
        this.parentInjector = parentInjector;
        this.customTokens = customTokens;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    get(token, notFoundValue) {
        /** @type {?} */
        const value = this.customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this.parentInjector.get(token, notFoundValue);
    }
}
if (false) {
    /**
     * @type {?}
     * @private
     */
    ModalInjector.prototype.parentInjector;
    /**
     * @type {?}
     * @private
     */
    ModalInjector.prototype.customTokens;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modal/modal.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MODAL_DATA = new InjectionToken('ModalData');
class ModalService {
    /**
     * @param {?} document
     * @param {?} applicationRef
     * @param {?} componentFactoryResolver
     * @param {?} injector
     */
    constructor(document, applicationRef, componentFactoryResolver, injector) {
        this.document = document;
        this.applicationRef = applicationRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
    }
    /**
     * @private
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    create(component, data) {
        /** @type {?} */
        const modalRef = new ModalRef();
        /** @type {?} */
        const injectionTokens = new WeakMap([
            [MODAL_DATA, data],
            [ModalRef, modalRef],
        ]);
        /** @type {?} */
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ModalComponent);
        /** @type {?} */
        const componentRef = componentFactory.create(new ModalInjector(this.injector, injectionTokens));
        /** @type {?} */
        const domElem = (/** @type {?} */ (((/** @type {?} */ (componentRef.hostView)))
            .rootNodes[0]));
        this.applicationRef.attachView(componentRef.hostView);
        this.document.body.appendChild(domElem);
        modalRef.component = componentRef;
        modalRef.component.instance.componentType = component;
        return modalRef;
    }
    /**
     * @private
     * @param {?} modalRef
     * @return {?}
     */
    remove(modalRef) {
        this.applicationRef.detachView(modalRef.component.hostView);
        modalRef.component.destroy();
        modalRef.component = null;
    }
    /**
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    open(component, data) {
        /** @type {?} */
        const modalRef = this.create(component, data);
        modalRef.closed$.pipe(take(1)).subscribe((/**
         * @return {?}
         */
        () => {
            this.remove(modalRef);
        }));
        return modalRef;
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });
/** @nocollapse */
ModalService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ApplicationRef },
    { type: ComponentFactoryResolver },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @protected
     */
    ModalService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    ModalService.prototype.applicationRef;
    /**
     * @type {?}
     * @private
     */
    ModalService.prototype.componentFactoryResolver;
    /**
     * @type {?}
     * @private
     */
    ModalService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/password/password.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PasswordComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrClass = true;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    createControls(isDisabled) {
        this.control.insert(0, new FormControl({ value: '', disabled: isDisabled }));
        this.control.insert(1, new FormControl({ value: '', disabled: isDisabled }));
        this.control.insert(2, new FormControl({ value: '', disabled: isDisabled }));
        this.control.insert(3, new FormControl({ value: '', disabled: isDisabled }));
    }
    /**
     * @return {?}
     */
    destroyControls() {
        this.control.removeAt(3);
        this.control.removeAt(2);
        this.control.removeAt(1);
        this.control.removeAt(0);
    }
    /**
     * @return {?}
     */
    createLabels() {
        /** @type {?} */
        const labels = [];
        this.field.config.options.forEach((/**
         * @param {?} label
         * @return {?}
         */
        (label) => {
            /** @type {?} */
            let extension = 'th';
            label = label.toString();
            if (label.endsWith('1')) {
                extension = 'st';
            }
            else if (label.endsWith('2')) {
                extension = 'nd';
            }
            else if (label.endsWith('3')) {
                extension = 'rd';
            }
            labels.push(`${label}${extension}`);
        }));
        return labels;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.field.isFieldset = true;
        this.control = (/** @type {?} */ (this.field.formGroup.get(this.field.config.name)));
        this.createControls(this.control.disabled);
        this.labels = this.createLabels();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyControls();
    }
}
PasswordComponent.ɵfac = function PasswordComponent_Factory(t) { return new (t || PasswordComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
PasswordComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordComponent, selectors: [["dlg-password"]], hostVars: 2, hostBindings: function PasswordComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-password", ctx.attrClass);
    } }, decls: 22, vars: 22, consts: [[3, "formGroup"], ["dlgAutotab", "", 1, "dlg-input", 3, "formArrayName"], [1, "dlg-password__character"], ["maxlength", "1", "type", "password", "formControlName", "0", "autocomplete", "off"], ["autotab", ""], [1, "dlg-field__label", 3, "for"], ["maxlength", "1", "type", "password", "formControlName", "1", "autocomplete", "off"], ["maxlength", "1", "type", "password", "formControlName", "2", "autocomplete", "off"], ["maxlength", "1", "type", "password", "formControlName", "3", "autocomplete", "off"]], template: function PasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "input", 3, 4);
        ɵngcc0.ɵɵelementStart(5, "label", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelement(8, "input", 6, 4);
        ɵngcc0.ɵɵelementStart(10, "label", 5);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelement(13, "input", 7, 4);
        ɵngcc0.ɵɵelementStart(15, "label", 5);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵelement(18, "input", 8, 4);
        ɵngcc0.ɵɵelementStart(20, "label", 5);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formArrayName", ctx.field.config.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-first")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-first");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels[0]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-second")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-second");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels[1]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-third")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-third");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels[2]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-fourth")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-fourth");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.labels[3]);
    } }, dependencies: [ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.MaxLengthValidator, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName, ɵngcc2.FormArrayName, AutotabDirective], encapsulation: 2 });
/** @nocollapse */
PasswordComponent.ctorParameters = () => [
    { type: FieldComponent }
];
PasswordComponent.propDecorators = {
    attrClass: [{ type: HostBinding, args: ['class.dlg-password',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-password',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <div class=\"dlg-input\" [formArrayName]=\"field.config.name\" dlgAutotab>\n    <div class=\"dlg-password__character\">\n      <input\n        maxlength=\"1\"\n        type=\"password\"\n        [attr.id]=\"field.labelFor + '-first'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"0\"\n        autocomplete=\"off\"\n        #autotab\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \" />\n      <label class=\"dlg-field__label\" for=\"{{ field.labelFor }}-first\">{{\n        labels[0]\n      }}</label>\n    </div>\n    <div class=\"dlg-password__character\">\n      <input\n        maxlength=\"1\"\n        type=\"password\"\n        [attr.id]=\"field.labelFor + '-second'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"1\"\n        autocomplete=\"off\"\n        #autotab\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \" />\n      <label class=\"dlg-field__label\" for=\"{{ field.labelFor }}-second\">{{\n        labels[1]\n      }}</label>\n    </div>\n    <div class=\"dlg-password__character\">\n      <input\n        maxlength=\"1\"\n        type=\"password\"\n        [attr.id]=\"field.labelFor + '-third'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"2\"\n        autocomplete=\"off\"\n        #autotab\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \" />\n      <label class=\"dlg-field__label\" for=\"{{ field.labelFor }}-third\">{{\n        labels[2]\n      }}</label>\n    </div>\n    <div class=\"dlg-password__character\">\n      <input\n        maxlength=\"1\"\n        type=\"password\"\n        [attr.id]=\"field.labelFor + '-fourth'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"3\"\n        autocomplete=\"off\"\n        #autotab\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \" />\n      <label class=\"dlg-field__label\" for=\"{{ field.labelFor }}-fourth\">{{\n        labels[3]\n      }}</label>\n    </div>\n  </div>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['class.dlg-password']
        }] }); })();
if (false) {
    /** @type {?} */
    PasswordComponent.prototype.attrClass;
    /** @type {?} */
    PasswordComponent.prototype.control;
    /** @type {?} */
    PasswordComponent.prototype.labels;
    /** @type {?} */
    PasswordComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/radio/radio.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RadioComponent {
    /**
     * @param {?} elementRef
     * @param {?} field
     */
    constructor(elementRef, field) {
        this.elementRef = elementRef;
        this.field = field;
        this.attrClass = true;
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set theming(theme) {
        this.elementRef.nativeElement.classList.add('dlg-radio-group--' + theme);
    }
    /**
     * @param {?} option
     * @return {?}
     */
    displayAsValue(option) {
        if (typeof option === 'object' && this.field.config.displayValue) {
            return (/** @type {?} */ (option[this.field.config.displayValue]));
        }
        else {
            return (/** @type {?} */ (option));
        }
    }
    /**
     * @param {?} option
     * @return {?}
     */
    displayAsId(option) {
        if (typeof option === 'object') {
            /** @type {?} */
            const name = this.displayAsValue(option);
            return option['key']
                ? `${this.field.labelFor}-${option['key']}`
                : `${this.field.labelFor}-${name}`;
        }
        else {
            return `${this.field.labelFor}-${option.replace(/ /g, '-')}`;
        }
    }
    // Safari bug: https://codepen.io/majornista/pen/BWNxrz
    /**
     * @param {?} event
     * @return {?}
     */
    setFocus(event) {
        /** @type {?} */
        const input = (/** @type {?} */ (event.target));
        input.focus();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.control = this.field.formGroup.get(this.field.config.name);
        if (this.theme) {
            this.theming = this.theme;
        }
        this.field.isFieldset = true;
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (typeof this.control.value === 'object') {
                /** @type {?} */
                const value = this.field.config.options.filter((/**
                 * @param {?} object
                 * @return {?}
                 */
                object => {
                    if (JSON.stringify(object) === JSON.stringify(this.control.value)) {
                        return true;
                    }
                }))[0];
                this.control.patchValue(value);
            }
        }));
    }
}
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
RadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["dlg-radio"]], hostVars: 2, hostBindings: function RadioComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-radio-group", ctx.attrClass);
    } }, inputs: { theme: "theme" }, decls: 1, vars: 1, consts: [["class", "dlg-radio", 3, "formGroup", 4, "ngFor", "ngForOf"], [1, "dlg-radio", 3, "formGroup"], ["type", "radio", 3, "formControlName", "value", "click"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RadioComponent_div_0_Template, 4, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.config.options);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc2.DefaultValueAccessor, ɵngcc2.RadioControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName], encapsulation: 2 });
/** @nocollapse */
RadioComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: FieldComponent }
];
RadioComponent.propDecorators = {
    theme: [{ type: Input }],
    attrClass: [{ type: HostBinding, args: ['class.dlg-radio-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-radio',
                template: "<div\n  *ngFor=\"let option of field.config.options; let i = index\"\n  class=\"dlg-radio\"\n  [formGroup]=\"field.formGroup\">\n  <input\n    type=\"radio\"\n    [attr.id]=\"displayAsId(option)\"\n    [attr.name]=\"field.labelFor\"\n    [attr.aria-label]=\"\n      field.config.ariaLabels ? field.config.ariaLabels[i] : undefined\n    \"\n    [formControlName]=\"field.config.name\"\n    [value]=\"option\"\n    (click)=\"setFocus($event)\" />\n  <label [attr.for]=\"displayAsId(option)\">{{ displayAsValue(option) }}</label>\n</div>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['class.dlg-radio-group']
        }], theme: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    RadioComponent.prototype.theme;
    /** @type {?} */
    RadioComponent.prototype.attrClass;
    /** @type {?} */
    RadioComponent.prototype.control;
    /**
     * @type {?}
     * @private
     */
    RadioComponent.prototype.elementRef;
    /** @type {?} */
    RadioComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/select/select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const dlgSelectClass = 'dlg-select';
class SelectComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrClass = `${dlgSelectClass}`;
        this.optionGroups = [];
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set resize(val) {
        this.attrClass =
            val === true || val === 'true'
                ? `${dlgSelectClass} ${dlgSelectClass}--resize`
                : `${dlgSelectClass}`;
    }
    /**
     * @param {?} val1
     * @param {?} val2
     * @return {?}
     */
    compareFn(val1, val2) {
        if (typeof val1 === 'object') {
            /** @type {?} */
            const key = Object.keys(val1)[0];
            return val1 && val2 ? val1[key] === val2[key] : val1 === val2;
        }
        else {
            return val1 && val2 ? val1 === val2 : val1 === val2;
        }
    }
    /**
     * @param {?} option
     * @return {?}
     */
    displayAsValue(option) {
        return (/** @type {?} */ ((typeof option === 'object' && this.field.config.displayValue
            ? ((/** @type {?} */ (option[this.field.config.displayValue])))
            : option)));
    }
    /**
     * @return {?}
     */
    getOptionGroups() {
        if (this.field.config.options) {
            this.optionGroups = Object.getOwnPropertyNames(this.field.config.options);
            return this.optionGroups.length ? this.optionGroups : [];
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.control = this.field.formGroup.get(this.field.config.name);
        if (this.control.value) {
            this.control.markAsDirty();
        }
    }
}
SelectComponent.ɵfac = function SelectComponent_Factory(t) { return new (t || SelectComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
SelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["dlg-select"]], hostVars: 2, hostBindings: function SelectComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.attrClass);
    } }, inputs: { resize: "resize" }, decls: 5, vars: 9, consts: [[3, "formGroup"], [3, "formControlName", "id", "compareWith"], ["value", "", "disabled", "", "hidden", "", 4, "ngIf"], [4, "ngIf"], ["value", "", "disabled", "", "hidden", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [3, "label", 4, "ngFor", "ngForOf"], [3, "label"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "select", 1);
        ɵngcc0.ɵɵtemplate(2, SelectComponent_option_2_Template, 2, 1, "option", 2);
        ɵngcc0.ɵɵtemplate(3, SelectComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, SelectComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.field.config.name)("id", ctx.field.labelFor)("compareWith", ctx.compareFn);
        ɵngcc0.ɵɵattribute("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.config == null ? null : ctx.field.config.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.field.config == null ? null : ctx.field.config.hasOptionGroups));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.field.config == null ? null : ctx.field.config.hasOptionGroups) && ctx.getOptionGroups());
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.NgSelectOption, ɵngcc2.ɵNgSelectMultipleOption, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName], encapsulation: 2 });
/** @nocollapse */
SelectComponent.ctorParameters = () => [
    { type: FieldComponent }
];
SelectComponent.propDecorators = {
    resize: [{ type: Input }],
    attrClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-select',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <select\n    [formControlName]=\"field.config.name\"\n    [id]=\"field.labelFor\"\n    [attr.name]=\"field.labelFor\"\n    [compareWith]=\"compareFn\"\n    [attr.aria-describedby]=\"\n      field.config?.hint ? field.labelFor + '-hint' : null\n    \">\n    <option *ngIf=\"field.config?.placeholder\" value=\"\" disabled hidden>\n      {{ field.config.placeholder }}\n    </option>\n    <ng-container *ngIf=\"!field.config?.hasOptionGroups\">\n      <option *ngFor=\"let option of field.config.options\" [ngValue]=\"option\">\n        {{ displayAsValue(option) }}\n      </option>\n    </ng-container>\n    <ng-container *ngIf=\"field.config?.hasOptionGroups && getOptionGroups()\">\n      <optgroup *ngFor=\"let optionGroup of optionGroups\" [label]=\"optionGroup\">\n        <option\n          *ngFor=\"let optionInGroup of field.config.options[optionGroup]\"\n          [ngValue]=\"displayAsValue(optionInGroup)\">\n          {{ displayAsValue(optionInGroup) }}\n        </option>\n      </optgroup>\n    </ng-container>\n  </select>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['class']
        }], resize: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    SelectComponent.prototype.attrClass;
    /** @type {?} */
    SelectComponent.prototype.control;
    /** @type {?} */
    SelectComponent.prototype.optionGroups;
    /** @type {?} */
    SelectComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/sortcode/sortcode.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SortCodeComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrClass = true;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    createControls(isDisabled) {
        if (this.control.length !== 3) {
            this.control.insert(0, new FormControl({ value: '', disabled: isDisabled }));
            this.control.insert(1, new FormControl({ value: '', disabled: isDisabled }));
            this.control.insert(2, new FormControl({ value: '', disabled: isDisabled }));
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.field.isFieldset = true;
        this.control = (/** @type {?} */ (this.field.formGroup.get(this.field.config.name)));
        this.createControls(this.control.disabled);
    }
}
SortCodeComponent.ɵfac = function SortCodeComponent_Factory(t) { return new (t || SortCodeComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
SortCodeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SortCodeComponent, selectors: [["dlg-sortcode"]], hostVars: 2, hostBindings: function SortCodeComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dlg-sortcode", ctx.attrClass);
    } }, decls: 17, vars: 14, consts: [[3, "formGroup"], ["dlgAutotab", "", 1, "dlg-input", 3, "formArrayName"], [1, "dlg-sortcode__section"], [3, "for"], ["maxlength", "2", "formControlName", "0", "autocomplete", "off"], ["autotab", ""], ["maxlength", "2", "formControlName", "1", "autocomplete", "off"], ["maxlength", "2", "formControlName", "2", "autocomplete", "off"]], template: function SortCodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "First two digits");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "input", 4, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2)(8, "label", 3);
        ɵngcc0.ɵɵtext(9, "Second two digits");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "input", 6, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2)(13, "label", 3);
        ɵngcc0.ɵɵtext(14, "Last two digits");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "input", 7, 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formArrayName", ctx.field.config.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-first");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-first")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-second");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-second")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("for", "", ctx.field.labelFor, "-last");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.field.labelFor + "-last")("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null);
    } }, dependencies: [ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.MaxLengthValidator, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName, ɵngcc2.FormArrayName, AutotabDirective], encapsulation: 2 });
/** @nocollapse */
SortCodeComponent.ctorParameters = () => [
    { type: FieldComponent }
];
SortCodeComponent.propDecorators = {
    attrClass: [{ type: HostBinding, args: ['class.dlg-sortcode',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortCodeComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-sortcode',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <div class=\"dlg-input\" [formArrayName]=\"field.config.name\" dlgAutotab>\n    <div class=\"dlg-sortcode__section\">\n      <label for=\"{{ field.labelFor }}-first\">First two digits</label>\n      <input\n        maxlength=\"2\"\n        [attr.id]=\"field.labelFor + '-first'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"0\"\n        autocomplete=\"off\"\n        #autotab\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \" />\n    </div>\n    <div class=\"dlg-sortcode__section\">\n      <label for=\"{{ field.labelFor }}-second\">Second two digits</label>\n      <input\n        maxlength=\"2\"\n        [attr.id]=\"field.labelFor + '-second'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"1\"\n        autocomplete=\"off\"\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \"\n        #autotab />\n    </div>\n    <div class=\"dlg-sortcode__section\">\n      <label for=\"{{ field.labelFor }}-last\">Last two digits</label>\n      <input\n        maxlength=\"2\"\n        [attr.id]=\"field.labelFor + '-last'\"\n        [attr.name]=\"field.labelFor\"\n        formControlName=\"2\"\n        autocomplete=\"off\"\n        [attr.aria-describedby]=\"\n          field.config?.hint ? field.labelFor + '-hint' : null\n        \"\n        #autotab />\n    </div>\n  </div>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['class.dlg-sortcode']
        }] }); })();
if (false) {
    /** @type {?} */
    SortCodeComponent.prototype.attrClass;
    /** @type {?} */
    SortCodeComponent.prototype.control;
    /** @type {?} */
    SortCodeComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/textarea/textarea.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TextareaComponent {
    /**
     * @param {?} field
     */
    constructor(field) {
        this.field = field;
        this.attrAutocomplete = 'off';
        this.attrClass = 'dlg-textarea';
    }
    /**
     * @param {?} isAutocomplete
     * @return {?}
     */
    set autocomplete(isAutocomplete) {
        this.attrAutocomplete = isAutocomplete ? 'on' : 'off';
    }
}
TextareaComponent.ɵfac = function TextareaComponent_Factory(t) { return new (t || TextareaComponent)(ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
TextareaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["dlg-textarea"]], hostVars: 2, hostBindings: function TextareaComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.attrClass);
    } }, inputs: { autocomplete: "autocomplete", attrMinLength: ["minlength", "attrMinLength"], attrMaxLength: ["maxlength", "attrMaxLength"] }, decls: 2, vars: 9, consts: [[3, "formGroup"], [3, "id", "formControlName"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelement(1, "textarea", 1);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.field.labelFor)("formControlName", ctx.field.config.name);
        ɵngcc0.ɵɵattribute("placeholder", (ctx.field.config == null ? null : ctx.field.config.placeholder) || null)("name", ctx.field.labelFor)("aria-describedby", (ctx.field.config == null ? null : ctx.field.config.hint) ? ctx.field.labelFor + "-hint" : null)("minlength", ctx.attrMinLength)("maxlength", ctx.attrMaxLength)("autocomplete", ctx.attrAutocomplete);
    } }, dependencies: [ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgControlStatusGroup, ɵngcc2.MinLengthValidator, ɵngcc2.MaxLengthValidator, ɵngcc2.FormGroupDirective, ɵngcc2.FormControlName], encapsulation: 2 });
/** @nocollapse */
TextareaComponent.ctorParameters = () => [
    { type: FieldComponent }
];
TextareaComponent.propDecorators = {
    attrMinLength: [{ type: Input, args: ['minlength',] }],
    attrMaxLength: [{ type: Input, args: ['maxlength',] }],
    autocomplete: [{ type: Input }],
    attrClass: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-textarea',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <textarea\n    [attr.placeholder]=\"field.config?.placeholder || null\"\n    [id]=\"field.labelFor\"\n    [attr.name]=\"field.labelFor\"\n    [attr.aria-describedby]=\"\n      field.config?.hint ? field.labelFor + '-hint' : null\n    \"\n    [attr.minlength]=\"attrMinLength\"\n    [attr.maxlength]=\"attrMaxLength\"\n    [attr.autocomplete]=\"attrAutocomplete\"\n    [formControlName]=\"field.config.name\"></textarea>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: FieldComponent }]; }, { attrClass: [{
            type: HostBinding,
            args: ['class']
        }], autocomplete: [{
            type: Input
        }], attrMinLength: [{
            type: Input,
            args: ['minlength']
        }], attrMaxLength: [{
            type: Input,
            args: ['maxlength']
        }] }); })();
if (false) {
    /** @type {?} */
    TextareaComponent.prototype.attrAutocomplete;
    /** @type {?} */
    TextareaComponent.prototype.attrMinLength;
    /** @type {?} */
    TextareaComponent.prototype.attrMaxLength;
    /** @type {?} */
    TextareaComponent.prototype.attrClass;
    /** @type {?} */
    TextareaComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/typeahead/typeahead.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TypeaheadComponent {
    /**
     * @param {?} elementRef
     * @param {?} field
     */
    constructor(elementRef, field) {
        this.elementRef = elementRef;
        this.field = field;
        // tslint:disable-next-line:whitespace
        this.displayOptionHeight = 40;
        // tslint:disable-next-line:whitespace
        this.displayOptionLimit = 5;
        this.classAttr = 'dlg-typeahead';
        this.term$ = new Subject();
        this.subscription = new Subscription();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown(e) {
        if (e.code.toLowerCase() === 'tab') {
            this.hide();
            return;
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyUp(e) {
        if (e.code.toLowerCase() === 'escape') {
            this.hide();
            return;
        }
        if (e.code.toLowerCase() === 'arrowup') {
            this.prevMatch();
            return;
        }
        if (e.code.toLowerCase() === 'arrowdown') {
            this.nextMatch();
            return;
        }
        if (e.code.toLowerCase() === 'enter') {
            if (this.activeValue) {
                this.setValue(this.activeValue);
                return;
            }
        }
        this.search(this.control.value);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onClick(e) {
        if (this.inputElement !== e.target && this.isListening) {
            this.hide();
        }
    }
    /**
     * @return {?}
     */
    prevMatch() {
        if (this.filteredOptionsIndex < this.filteredOptions.length &&
            this.filteredOptionsIndex > 0) {
            this.filteredOptionsIndex--;
        }
        this.setActive(this.filteredOptionsIndex);
    }
    /**
     * @return {?}
     */
    nextMatch() {
        if (this.filteredOptionsIndex < this.filteredOptions.length - 1 &&
            this.filteredOptionsIndex >= -1) {
            this.filteredOptionsIndex++;
        }
        this.setActive(this.filteredOptionsIndex);
    }
    /**
     * @param {?} index
     * @return {?}
     */
    setActive(index) {
        this.activeValue = this.filteredOptions[index];
        /** @type {?} */
        const el = document.getElementsByClassName('dlg-typeahead__menu__item')[index];
        ((/** @type {?} */ (el))).focus();
        this.scrollIntoView();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    setValue(value) {
        this.control.setValue(value);
        this.inputElement.value = this.displayAsValue(value);
        this.reset();
        this.hide();
        this.inputElement.focus();
    }
    /**
     * @param {?} term
     * @return {?}
     */
    search(term) {
        this.term$.next(term);
    }
    /**
     * @return {?}
     */
    reset() {
        this.filteredOptionsIndex = -1;
        this.activeValue = null;
    }
    /**
     * @return {?}
     */
    hide() {
        this.matchValue(this.control.value);
        this.panel = null;
        this.isListening = false;
        this.isOpen = false;
        this.inputElement.setAttribute('aria-expanded', `${this.isOpen}`);
    }
    /**
     * @return {?}
     */
    show() {
        this.isOpen = true;
        this.inputElement.setAttribute('aria-expanded', `${this.isOpen}`);
    }
    /**
     * @param {?} term
     * @return {?}
     */
    getData(term) {
        this.term = term;
        this.isListening = true;
        if (this.term.length >= 3) {
            if (this.fuzzyMatch !== null && this.fuzzyMatch !== undefined) {
                /** @type {?} */
                const fuzzyMatch = typeof this.fuzzyMatch === 'number' ? this.fuzzyMatch : 0.2;
                this.filteredOptions = this.fuzzySearch(term, fuzzyMatch);
            }
            else {
                this.filteredOptions = this.items.filter((/**
                 * @param {?} item
                 * @return {?}
                 */
                item => {
                    /** @type {?} */
                    const value = this.displayAsValue(item);
                    return value.toLowerCase().indexOf(term.toLowerCase()) >= 0;
                }));
            }
            if (this.filteredOptions.length > 0) {
                this.show();
            }
        }
        else {
            this.filteredOptions = [];
            this.isOpen = false;
            this.inputElement.setAttribute('aria-expanded', `${this.isOpen}`);
            this.reset();
        }
    }
    /**
     * @param {?} option
     * @return {?}
     */
    displayAsValue(option) {
        if (typeof option === 'object' && this.field.config.displayValue) {
            return (/** @type {?} */ (option[this.field.config.displayValue]));
        }
        else {
            return (/** @type {?} */ (option));
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    matchValue(value) {
        if (this.items) {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.items.length; i++) {
                if (value === this.items[i]) {
                    // Valid
                    return true;
                }
            }
            // Invalid
            this.control.setValue('');
            this.inputElement.value = this.term;
            return false;
        }
    }
    // Scroll Navigated Item to view
    /**
     * @return {?}
     */
    scrollIntoView() {
        /** @type {?} */
        const activeOptionIndex = this.filteredOptionsIndex;
        /** @type {?} */
        const activeOptionOffset = activeOptionIndex * this.displayOptionHeight;
        /** @type {?} */
        const panelTop = this.getScrollTop();
        // Scroll Up
        if (activeOptionOffset < panelTop) {
            this.setScrollTop(activeOptionOffset);
            // Scroll Down
        }
        else if (activeOptionOffset + this.displayOptionHeight >
            panelTop + this.displayOptionLimit * this.displayOptionHeight) {
            /** @type {?} */
            const scrollTop = activeOptionOffset -
                this.displayOptionLimit * this.displayOptionHeight +
                this.displayOptionHeight;
            this.setScrollTop(Math.max(0, scrollTop));
        }
    }
    /**
     * @param {?} scrollTop
     * @return {?}
     */
    setScrollTop(scrollTop) {
        if (this.panel) {
            this.panel.nativeElement.scrollTop = scrollTop;
        }
    }
    /**
     * @return {?}
     */
    getScrollTop() {
        return this.panel ? this.panel.nativeElement.scrollTop : 0;
    }
    /**
     * @param {?} option
     * @return {?}
     */
    optionPosition(option) {
        return this.items.findIndex((/**
         * @param {?} item
         * @return {?}
         */
        item => item === option)) || null;
    }
    /**
     * @private
     * @param {?} term
     * @param {?} threshold
     * @return {?}
     */
    fuzzySearch(term, threshold) {
        /** @type {?} */
        const fuse = new Fuse(this.items.map((/**
         * @param {?} item
         * @return {?}
         */
        item => item.value)), { ignoreLocation: true, threshold });
        /** @type {?} */
        const indexes = fuse.search(term).map((/**
         * @param {?} match
         * @return {?}
         */
        match => match.refIndex));
        return this.items.filter((/**
         * @param {?} _
         * @param {?} i
         * @return {?}
         */
        (_, i) => indexes.includes(i)));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.control = this.field.formGroup.get(this.field.config.name);
        this.items = this.field.config.options;
        this.inputElement = this.elementRef.nativeElement.querySelector('input');
        this.inputElement.setAttribute('role', 'combobox');
        this.inputElement.setAttribute('aria-autocomplete', 'list');
        this.inputElement.setAttribute('aria-control', this.field.config.name);
        this.isOpen = false;
        this.inputElement.setAttribute('aria-expanded', `${this.isOpen}`);
        this.filteredOptionsIndex = -1;
        this.subscription = this.term$.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => this.getData(data)));
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (typeof this.control.value === 'object') {
            /** @type {?} */
            const value = this.field.config.options.filter((/**
             * @param {?} object
             * @return {?}
             */
            object => {
                if (JSON.stringify(object) === JSON.stringify(this.control.value)) {
                    return true;
                }
            }))[0];
            this.control.setValue(value);
            this.inputElement.value = this.displayAsValue(value);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
TypeaheadComponent.ɵfac = function TypeaheadComponent_Factory(t) { return new (t || TypeaheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(FieldComponent)); };
TypeaheadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypeaheadComponent, selectors: [["dlg-typeahead"]], viewQuery: function TypeaheadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t.first);
    } }, hostVars: 1, hostBindings: function TypeaheadComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function TypeaheadComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup", function TypeaheadComponent_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); })("mousedown", function TypeaheadComponent_mousedown_HostBindingHandler($event) { return ctx.onClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.classAttr);
    } }, inputs: { displayOptionHeight: ["optionHeight", "displayOptionHeight"], displayOptionLimit: ["optionLimit", "displayOptionLimit"], fuzzyMatch: "fuzzyMatch" }, decls: 5, vars: 2, consts: [[3, "formGroup"], ["class", "dlg-typeahead__menu", 4, "ngIf"], [1, "hg-a11y-hidden"], [1, "dlg-typeahead__menu"], ["panel", ""], ["tabindex", "-1", "role", "option", "class", "dlg-typeahead__menu__item", 3, "is-active", "mousedown", 4, "ngFor", "ngForOf"], ["tabindex", "-1", "role", "option", 1, "dlg-typeahead__menu__item", 3, "mousedown"]], template: function TypeaheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵelement(1, "dlg-input");
        ɵngcc0.ɵɵtemplate(2, TypeaheadComponent_ul_2_Template, 3, 1, "ul", 1);
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵtext(4, "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.field.formGroup);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen && ctx.filteredOptions.length);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, InputComponent], encapsulation: 2 });
/** @nocollapse */
TypeaheadComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: FieldComponent }
];
TypeaheadComponent.propDecorators = {
    displayOptionHeight: [{ type: Input, args: ['optionHeight',] }],
    displayOptionLimit: [{ type: Input, args: ['optionLimit',] }],
    fuzzyMatch: [{ type: Input }],
    classAttr: [{ type: HostBinding, args: ['attr.class',] }],
    panel: [{ type: ViewChild, args: ['panel', { static: false },] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    onKeyUp: [{ type: HostListener, args: ['keyup', ['$event'],] }],
    onClick: [{ type: HostListener, args: ['document:mousedown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadComponent, [{
        type: Component,
        args: [{
                selector: 'dlg-typeahead',
                template: "<ng-container [formGroup]=\"field.formGroup\">\n  <dlg-input></dlg-input>\n  <ul\n    class=\"dlg-typeahead__menu\"\n    *ngIf=\"isOpen && filteredOptions.length\"\n    #panel>\n    <li\n      tabindex=\"-1\"\n      role=\"option\"\n      *ngFor=\"let option of filteredOptions\"\n      (mousedown)=\"setValue(option)\"\n      class=\"dlg-typeahead__menu__item\"\n      [class.is-active]=\"activeValue === option\"\n      [attr.aria-selected]=\"activeValue === option\"\n      [attr.aria-posinset]=\"optionPosition(option)\"\n      [attr.aria-setsize]=\"items?.length\">\n      {{ displayAsValue(option) }}\n    </li>\n  </ul>\n  <span class=\"hg-a11y-hidden\"\n    >When autocomplete results are available use up and down arrows to review\n    and enter to select. Touch device users, explore by touch or with swipe\n    gestures.\n  </span>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: FieldComponent }]; }, { displayOptionHeight: [{
            type: Input,
            args: ['optionHeight']
        }], displayOptionLimit: [{
            type: Input,
            args: ['optionLimit']
        }], classAttr: [{
            type: HostBinding,
            args: ['attr.class']
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ['document:mousedown', ['$event']]
        }], panel: [{
            type: ViewChild,
            args: ['panel', { static: false }]
        }], fuzzyMatch: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    TypeaheadComponent.prototype.displayOptionHeight;
    /** @type {?} */
    TypeaheadComponent.prototype.displayOptionLimit;
    /** @type {?} */
    TypeaheadComponent.prototype.fuzzyMatch;
    /** @type {?} */
    TypeaheadComponent.prototype.classAttr;
    /** @type {?} */
    TypeaheadComponent.prototype.panel;
    /** @type {?} */
    TypeaheadComponent.prototype.control;
    /** @type {?} */
    TypeaheadComponent.prototype.term$;
    /** @type {?} */
    TypeaheadComponent.prototype.items;
    /** @type {?} */
    TypeaheadComponent.prototype.filteredOptions;
    /** @type {?} */
    TypeaheadComponent.prototype.filteredOptionsIndex;
    /** @type {?} */
    TypeaheadComponent.prototype.activeValue;
    /** @type {?} */
    TypeaheadComponent.prototype.isOpen;
    /** @type {?} */
    TypeaheadComponent.prototype.inputElement;
    /** @type {?} */
    TypeaheadComponent.prototype.isListening;
    /** @type {?} */
    TypeaheadComponent.prototype.term;
    /** @type {?} */
    TypeaheadComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    TypeaheadComponent.prototype.elementRef;
    /** @type {?} */
    TypeaheadComponent.prototype.field;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dlg-walrus.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DlgWalrusModule {
}
DlgWalrusModule.ɵfac = function DlgWalrusModule_Factory(t) { return new (t || DlgWalrusModule)(); };
DlgWalrusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DlgWalrusModule });
DlgWalrusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [ModalService], imports: [CommonModule,
        ReactiveFormsModule,
        A11yModule,
        FormsModule,
        NgbModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DlgWalrusModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    A11yModule,
                    FormsModule,
                    NgbModule,
                ],
                declarations: [
                    FieldComponent,
                    HintComponent,
                    ButtonComponent,
                    ButtonAnchorComponent,
                    InputComponent,
                    TextareaComponent,
                    SelectComponent,
                    CheckboxComponent,
                    CheckboxesComponent,
                    RadioComponent,
                    TypeaheadComponent,
                    DatepickerComponent,
                    CalendarComponent,
                    IconComponent,
                    FieldPrefixComponent,
                    FieldLinkComponent,
                    AlertComponent,
                    InputGroupComponent,
                    SortCodeComponent,
                    PasswordComponent,
                    AutotabDirective,
                    ModalComponent,
                    ModalActionsComponent,
                ],
                exports: [
                    FieldComponent,
                    HintComponent,
                    ButtonComponent,
                    ButtonAnchorComponent,
                    InputComponent,
                    TextareaComponent,
                    SelectComponent,
                    CheckboxComponent,
                    CheckboxesComponent,
                    RadioComponent,
                    TypeaheadComponent,
                    DatepickerComponent,
                    CalendarComponent,
                    IconComponent,
                    FieldPrefixComponent,
                    FieldLinkComponent,
                    AlertComponent,
                    InputGroupComponent,
                    SortCodeComponent,
                    PasswordComponent,
                    AutotabDirective,
                    ModalComponent,
                    ModalActionsComponent,
                ],
                providers: [ModalService],
                entryComponents: [ModalComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DlgWalrusModule, { declarations: function () { return [FieldComponent, HintComponent, ButtonComponent, ButtonAnchorComponent, InputComponent, TextareaComponent, SelectComponent, CheckboxComponent, CheckboxesComponent, RadioComponent, TypeaheadComponent, DatepickerComponent, CalendarComponent, IconComponent, FieldPrefixComponent, FieldLinkComponent, AlertComponent, InputGroupComponent, SortCodeComponent, PasswordComponent, AutotabDirective, ModalComponent, ModalActionsComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        A11yModule,
        FormsModule,
        NgbModule]; }, exports: function () { return [FieldComponent, HintComponent, ButtonComponent, ButtonAnchorComponent, InputComponent, TextareaComponent, SelectComponent, CheckboxComponent, CheckboxesComponent, RadioComponent, TypeaheadComponent, DatepickerComponent, CalendarComponent, IconComponent, FieldPrefixComponent, FieldLinkComponent, AlertComponent, InputGroupComponent, SortCodeComponent, PasswordComponent, AutotabDirective, ModalComponent, ModalActionsComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/field/field.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldConfig {
}
if (false) {
    /** @type {?} */
    FieldConfig.prototype.name;
    /** @type {?} */
    FieldConfig.prototype.label;
    /** @type {?} */
    FieldConfig.prototype.hint;
    /** @type {?} */
    FieldConfig.prototype.placeholder;
    /** @type {?} */
    FieldConfig.prototype.validation;
    /** @type {?} */
    FieldConfig.prototype.validationMessages;
}
class FieldOptionsConfig extends FieldConfig {
}
if (false) {
    /** @type {?} */
    FieldOptionsConfig.prototype.options;
    /** @type {?} */
    FieldOptionsConfig.prototype.displayValue;
}
class FieldDateConfig extends FieldConfig {
}
if (false) {
    /** @type {?} */
    FieldDateConfig.prototype.display;
    /** @type {?} */
    FieldDateConfig.prototype.format;
    /** @type {?} */
    FieldDateConfig.prototype.isDisabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: dlg-walrus.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AlertComponent, AutotabDirective, ButtonAnchorComponent, ButtonComponent, CalendarComponent, CheckboxComponent, CheckboxesComponent, DatepickerComponent, DlgWalrusModule, FieldComponent, FieldConfig, FieldDateConfig, FieldLinkComponent, FieldOptionsConfig, FieldPrefixComponent, Hint, HintComponent, IconComponent, InputComponent, InputGroupComponent, Layout, MODAL_DATA, ModalActionsComponent, ModalComponent, ModalInjector, ModalRef, ModalService, NgbDatepickerI18nCustom, PasswordComponent, RadioComponent, SelectComponent, SortCodeComponent, TextareaComponent, TypeaheadComponent, slideInOut as ɵa, fadeInOut as ɵb };

